// // // // import React, { useState, useEffect } from 'react';
// // // // import { FaSave, FaUpload, FaPlus, FaTrash, FaEyeDropper, FaFont } from 'react-icons/fa';

// // // // const HeroAdmin = () => {
// // // //   // Stan dla danych hero
// // // //   const [heroData, setHeroData] = useState({
// // // //     backgroundImage: "/images/hero.jpg",
// // // //     title: "Kolorowe Domki",
// // // //     subtitle: "Idealne miejsce nad morzem dla rodzin z dziećmi",
// // // //     titleStyle: {
// // // //       fontSize: "5xl",
// // // //       fontWeight: "extrabold",
// // // //       color: "#ffffff",
// // // //       textShadow: "0 2px 4px rgba(0,0,0,0.5)"
// // // //     },
// // // //     subtitleStyle: {
// // // //       fontSize: "xl",
// // // //       fontWeight: "light",
// // // //       color: "#ffffff",
// // // //       textShadow: "0 2px 4px rgba(0,0,0,0.5)"
// // // //     },
// // // //     overlay: {
// // // //       enabled: true,
// // // //       gradient: "bg-gradient-to-br from-black/60 to-black/30"
// // // //     },
// // // //     ctaButton: {
// // // //       enabled: false,
// // // //       text: "Rezerwuj teraz",
// // // //       style: {
// // // //         backgroundColor: "#f59e0b",
// // // //         color: "#ffffff",
// // // //         fontSize: "lg",
// // // //         padding: "12px 24px",
// // // //         borderRadius: "8px"
// // // //       }
// // // //     }
// // // //   });

// // // //   const [message, setMessage] = useState("");
// // // //   const [imageUploading, setImageUploading] = useState(false);
// // // //   const [fontSizes] = useState([
// // // //     { value: "sm", label: "Mały" },
// // // //     { value: "base", label: "Normalny" },
// // // //     { value: "lg", label: "Duży" },
// // // //     { value: "xl", label: "Bardzo duży" },
// // // //     { value: "2xl", label: "X-Large" },
// // // //     { value: "3xl", label: "2X-Large" },
// // // //     { value: "4xl", label: "3X-Large" },
// // // //     { value: "5xl", label: "4X-Large" },
// // // //     { value: "6xl", label: "5X-Large" },
// // // //     { value: "7xl", label: "6X-Large" }
// // // //   ]);

// // // //   // Załaduj dane z localStorage przy starcie
// // // //   useEffect(() => {
// // // //     const savedData = localStorage.getItem('heroData');
// // // //     if (savedData) {
// // // //       setHeroData(JSON.parse(savedData));
// // // //     }
// // // //   }, []);

// // // //   const saveData = () => {
// // // //     localStorage.setItem('heroData', JSON.stringify(heroData));
// // // //     setMessage("Zmiany zapisane pomyślnie!");
// // // //     setTimeout(() => setMessage(""), 3000);
// // // //   };

// // // //   const handleImageUpload = (e) => {
// // // //     const file = e.target.files[0];
// // // //     if (file) {
// // // //       setImageUploading(true);
      
// // // //       // Symulacja procesu uploadu
// // // //       setTimeout(() => {
// // // //         const reader = new FileReader();
// // // //         reader.onload = (event) => {
// // // //           const newImageUrl = event.target.result;
// // // //           setHeroData({
// // // //             ...heroData,
// // // //             backgroundImage: newImageUrl
// // // //           });
// // // //           setImageUploading(false);
// // // //         };
// // // //         reader.readAsDataURL(file);
// // // //       }, 1000);
// // // //     }
// // // //   };

// // // //   const handleTitleChange = (e) => {
// // // //     setHeroData({ ...heroData, title: e.target.value });
// // // //   };

// // // //   const handleSubtitleChange = (e) => {
// // // //     setHeroData({ ...heroData, subtitle: e.target.value });
// // // //   };

// // // //   const handleTitleStyleChange = (property, value) => {
// // // //     setHeroData({ 
// // // //       ...heroData, 
// // // //       titleStyle: { ...heroData.titleStyle, [property]: value } 
// // // //     });
// // // //   };

// // // //   const handleSubtitleStyleChange = (property, value) => {
// // // //     setHeroData({ 
// // // //       ...heroData, 
// // // //       subtitleStyle: { ...heroData.subtitleStyle, [property]: value } 
// // // //     });
// // // //   };

// // // //   const handleOverlayChange = (enabled) => {
// // // //     setHeroData({ 
// // // //       ...heroData, 
// // // //       overlay: { ...heroData.overlay, enabled } 
// // // //     });
// // // //   };

// // // //   const handleGradientChange = (e) => {
// // // //     setHeroData({ 
// // // //       ...heroData, 
// // // //       overlay: { ...heroData.overlay, gradient: e.target.value } 
// // // //     });
// // // //   };

// // // //   const handleCtaToggle = () => {
// // // //     setHeroData({ 
// // // //       ...heroData, 
// // // //       ctaButton: { ...heroData.ctaButton, enabled: !heroData.ctaButton.enabled } 
// // // //     });
// // // //   };

// // // //   const handleCtaTextChange = (e) => {
// // // //     setHeroData({ 
// // // //       ...heroData, 
// // // //       ctaButton: { ...heroData.ctaButton, text: e.target.value } 
// // // //     });
// // // //   };

// // // //   const handleCtaStyleChange = (property, value) => {
// // // //     setHeroData({ 
// // // //       ...heroData, 
// // // //       ctaButton: { 
// // // //         ...heroData.ctaButton, 
// // // //         style: { ...heroData.ctaButton.style, [property]: value } 
// // // //       } 
// // // //     });
// // // //   };

// // // //   // Funkcja do konwersji stylów na klasy Tailwind
// // // //   const getTailwindClasses = (style, type) => {
// // // //     const classes = [];
    
// // // //     if (type === 'title') {
// // // //       classes.push(`text-${style.fontSize}`);
// // // //       classes.push(`font-${style.fontWeight}`);
// // // //     } else if (type === 'subtitle') {
// // // //       classes.push(`text-${style.fontSize}`);
// // // //       classes.push(`font-${style.fontWeight}`);
// // // //     }
    
// // // //     return classes.join(' ');
// // // //   };

// // // //   // Predefiniowane gradienty do wyboru
// // // //   const gradients = [
// // // //     { value: "bg-gradient-to-br from-black/60 to-black/30", label: "Ciemny (domyślny)" },
// // // //     { value: "bg-gradient-to-br from-blue-900/60 to-blue-500/30", label: "Niebieski" },
// // // //     { value: "bg-gradient-to-br from-purple-900/60 to-purple-500/30", label: "Fioletowy" },
// // // //     { value: "bg-gradient-to-br from-green-900/60 to-green-500/30", label: "Zielony" },
// // // //     { value: "bg-gradient-to-br from-red-900/60 to-red-500/30", label: "Czerwony" },
// // // //     { value: "bg-gradient-to-br from-yellow-900/60 to-yellow-500/30", label: "Żółty" },
// // // //     { value: "bg-gradient-to-br from-pink-900/60 to-pink-500/30", label: "Różowy" },
// // // //     { value: "none", label: "Brak overlay" }
// // // //   ];

// // // //   return (
// // // //     <div className="min-h-screen bg-gray-100 p-6">
// // // //       <div className="max-w-5xl mx-auto bg-white rounded-lg shadow-md p-6">
// // // //         <h1 className="text-2xl font-bold mb-6 text-gray-800">Panel Administracyjny - Sekcja Hero</h1>
        
// // // //         {message && (
// // // //           <div className="mb-4 p-3 bg-green-100 text-green-700 rounded">
// // // //             {message}
// // // //           </div>
// // // //         )}
        
// // // //         <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
// // // //           {/* Panel edycji */}
// // // //           <div className="space-y-6">
// // // //             {/* Tło */}
// // // //             <div className="p-4 border border-gray-200 rounded-md">
// // // //               <h2 className="text-lg font-semibold mb-3">Tło</h2>
              
// // // //               <div className="mb-4">
// // // //                 <label className="block text-sm font-medium text-gray-700 mb-2">Zdjęcie tła</label>
// // // //                 <div className="flex items-center gap-4">
// // // //                   <div className="w-20 h-20 bg-gray-200 rounded-md overflow-hidden">
// // // //                     <img 
// // // //                       src={heroData.backgroundImage} 
// // // //                       alt="Podgląd tła" 
// // // //                       className="w-full h-full object-cover"
// // // //                     />
// // // //                   </div>
// // // //                   <label className="flex flex-col items-center justify-center w-full h-32 border-2 border-dashed border-gray-300 rounded-md cursor-pointer bg-gray-50 hover:bg-gray-100">
// // // //                     {imageUploading ? (
// // // //                       <div className="flex flex-col items-center justify-center">
// // // //                         <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-blue-500 mb-2"></div>
// // // //                         <span className="text-sm">Przesyłanie...</span>
// // // //                       </div>
// // // //                     ) : (
// // // //                       <>
// // // //                         <FaUpload className="w-8 h-8 text-gray-500 mb-2" />
// // // //                         <p className="text-sm text-gray-500 text-center">
// // // //                           <span className="font-semibold">Kliknij aby przesłać</span><br />
// // // //                           <span className="text-xs">PNG, JPG (max. 5MB)</span>
// // // //                         </p>
// // // //                         <input 
// // // //                           type="file" 
// // // //                           className="hidden" 
// // // //                           onChange={handleImageUpload} 
// // // //                           accept="image/*" 
// // // //                         />
// // // //                       </>
// // // //                     )}
// // // //                   </label>
// // // //                 </div>
// // // //               </div>
              
// // // //               <div className="mb-4">
// // // //                 <label className="block text-sm font-medium text-gray-700 mb-2">Overlay</label>
// // // //                 <div className="flex items-center gap-2">
// // // //                   <input
// // // //                     type="checkbox"
// // // //                     checked={heroData.overlay.enabled}
// // // //                     onChange={(e) => handleOverlayChange(e.target.checked)}
// // // //                     className="rounded border-gray-300 text-blue-600 focus:ring-blue-500"
// // // //                   />
// // // //                   <span>Włącz overlay</span>
// // // //                 </div>
// // // //               </div>
              
// // // //               {heroData.overlay.enabled && (
// // // //                 <div className="mb-4">
// // // //                   <label className="block text-sm font-medium text-gray-700 mb-2">Gradient overlay</label>
// // // //                   <select
// // // //                     value={heroData.overlay.gradient}
// // // //                     onChange={handleGradientChange}
// // // //                     className="w-full p-2 border border-gray-300 rounded-md"
// // // //                   >
// // // //                     {gradients.map((gradient) => (
// // // //                       <option key={gradient.value} value={gradient.value}>
// // // //                         {gradient.label}
// // // //                       </option>
// // // //                     ))}
// // // //                   </select>
// // // //                 </div>
// // // //               )}
// // // //             </div>
            
// // // //             {/* Tytuł */}
// // // //             <div className="p-4 border border-gray-200 rounded-md">
// // // //               <h2 className="text-lg font-semibold mb-3">Tytuł</h2>
              
// // // //               <div className="mb-4">
// // // //                 <label className="block text-sm font-medium text-gray-700 mb-2">Tekst tytułu</label>
// // // //                 <input
// // // //                   type="text"
// // // //                   value={heroData.title}
// // // //                   onChange={handleTitleChange}
// // // //                   className="w-full p-3 border border-gray-300 rounded-md"
// // // //                 />
// // // //               </div>
              
// // // //               <div className="grid grid-cols-2 gap-4 mb-4">
// // // //                 <div>
// // // //                   <label className="block text-sm font-medium text-gray-700 mb-2">Rozmiar czcionki</label>
// // // //                   <select
// // // //                     value={heroData.titleStyle.fontSize}
// // // //                     onChange={(e) => handleTitleStyleChange('fontSize', e.target.value)}
// // // //                     className="w-full p-2 border border-gray-300 rounded-md"
// // // //                   >
// // // //                     {fontSizes.map((size) => (
// // // //                       <option key={size.value} value={size.value}>
// // // //                         {size.label}
// // // //                       </option>
// // // //                     ))}
// // // //                   </select>
// // // //                 </div>
                
// // // //                 <div>
// // // //                   <label className="block text-sm font-medium text-gray-700 mb-2">Grubość czcionki</label>
// // // //                   <select
// // // //                     value={heroData.titleStyle.fontWeight}
// // // //                     onChange={(e) => handleTitleStyleChange('fontWeight', e.target.value)}
// // // //                     className="w-full p-2 border border-gray-300 rounded-md"
// // // //                   >
// // // //                     <option value="light">Light</option>
// // // //                     <option value="normal">Normal</option>
// // // //                     <option value="medium">Medium</option>
// // // //                     <option value="semibold">Semibold</option>
// // // //                     <option value="bold">Bold</option>
// // // //                     <option value="extrabold">Extrabold</option>
// // // //                   </select>
// // // //                 </div>
// // // //               </div>
              
// // // //               <div className="mb-4">
// // // //                 <label className="block text-sm font-medium text-gray-700 mb-2">Kolor tekstu</label>
// // // //                 <div className="flex items-center gap-2">
// // // //                   <input
// // // //                     type="color"
// // // //                     value={heroData.titleStyle.color}
// // // //                     onChange={(e) => handleTitleStyleChange('color', e.target.value)}
// // // //                     className="w-10 h-10 rounded border border-gray-300"
// // // //                   />
// // // //                   <input
// // // //                     type="text"
// // // //                     value={heroData.titleStyle.color}
// // // //                     onChange={(e) => handleTitleStyleChange('color', e.target.value)}
// // // //                     className="flex-1 p-2 border border-gray-300 rounded-md"
// // // //                   />
// // // //                 </div>
// // // //               </div>
// // // //             </div>
            
// // // //             {/* Podtytuł */}
// // // //             <div className="p-4 border border-gray-200 rounded-md">
// // // //               <h2 className="text-lg font-semibold mb-3">Podtytuł</h2>
              
// // // //               <div className="mb-4">
// // // //                 <label className="block text-sm font-medium text-gray-700 mb-2">Tekst podtytułu</label>
// // // //                 <input
// // // //                   type="text"
// // // //                   value={heroData.subtitle}
// // // //                   onChange={handleSubtitleChange}
// // // //                   className="w-full p-3 border border-gray-300 rounded-md"
// // // //                 />
// // // //               </div>
              
// // // //               <div className="grid grid-cols-2 gap-4 mb-4">
// // // //                 <div>
// // // //                   <label className="block text-sm font-medium text-gray-700 mb-2">Rozmiar czcionki</label>
// // // //                   <select
// // // //                     value={heroData.subtitleStyle.fontSize}
// // // //                     onChange={(e) => handleSubtitleStyleChange('fontSize', e.target.value)}
// // // //                     className="w-full p-2 border border-gray-300 rounded-md"
// // // //                   >
// // // //                     {fontSizes.map((size) => (
// // // //                       <option key={size.value} value={size.value}>
// // // //                         {size.label}
// // // //                       </option>
// // // //                     ))}
// // // //                   </select>
// // // //                 </div>
                
// // // //                 <div>
// // // //                   <label className="block text-sm font-medium text-gray-700 mb-2">Grubość czcionki</label>
// // // //                   <select
// // // //                     value={heroData.subtitleStyle.fontWeight}
// // // //                     onChange={(e) => handleSubtitleStyleChange('fontWeight', e.target.value)}
// // // //                     className="w-full p-2 border border-gray-300 rounded-md"
// // // //                   >
// // // //                     <option value="light">Light</option>
// // // //                     <option value="normal">Normal</option>
// // // //                     <option value="medium">Medium</option>
// // // //                     <option value="semibold">Semibold</option>
// // // //                     <option value="bold">Bold</option>
// // // //                     <option value="extrabold">Extrabold</option>
// // // //                   </select>
// // // //                 </div>
// // // //               </div>
              
// // // //               <div className="mb-4">
// // // //                 <label className="block text-sm font-medium text-gray-700 mb-2">Kolor tekstu</label>
// // // //                 <div className="flex items-center gap-2">
// // // //                   <input
// // // //                     type="color"
// // // //                     value={heroData.subtitleStyle.color}
// // // //                     onChange={(e) => handleSubtitleStyleChange('color', e.target.value)}
// // // //                     className="w-10 h-10 rounded border border-gray-300"
// // // //                   />
// // // //                   <input
// // // //                     type="text"
// // // //                     value={heroData.subtitleStyle.color}
// // // //                     onChange={(e) => handleSubtitleStyleChange('color', e.target.value)}
// // // //                     className="flex-1 p-2 border border-gray-300 rounded-md"
// // // //                   />
// // // //                 </div>
// // // //               </div>
// // // //             </div>
            
// // // //             {/* Przycisk CTA */}
// // // //             <div className="p-4 border border-gray-200 rounded-md">
// // // //               <h2 className="text-lg font-semibold mb-3">Przycisk Call-to-Action</h2>
              
// // // //               <div className="mb-4">
// // // //                 <div className="flex items-center gap-2 mb-3">
// // // //                   <input
// // // //                     type="checkbox"
// // // //                     checked={heroData.ctaButton.enabled}
// // // //                     onChange={handleCtaToggle}
// // // //                     className="rounded border-gray-300 text-blue-600 focus:ring-blue-500"
// // // //                   />
// // // //                   <span>Włącz przycisk CTA</span>
// // // //                 </div>
// // // //               </div>
              
// // // //               {heroData.ctaButton.enabled && (
// // // //                 <>
// // // //                   <div className="mb-4">
// // // //                     <label className="block text-sm font-medium text-gray-700 mb-2">Tekst przycisku</label>
// // // //                     <input
// // // //                       type="text"
// // // //                       value={heroData.ctaButton.text}
// // // //                       onChange={handleCtaTextChange}
// // // //                       className="w-full p-2 border border-gray-300 rounded-md"
// // // //                     />
// // // //                   </div>
                  
// // // //                   <div className="mb-4">
// // // //                     <label className="block text-sm font-medium text-gray-700 mb-2">Kolor tła</label>
// // // //                     <div className="flex items-center gap-2">
// // // //                       <input
// // // //                         type="color"
// // // //                         value={heroData.ctaButton.style.backgroundColor}
// // // //                         onChange={(e) => handleCtaStyleChange('backgroundColor', e.target.value)}
// // // //                         className="w-10 h-10 rounded border border-gray-300"
// // // //                       />
// // // //                       <input
// // // //                         type="text"
// // // //                         value={heroData.ctaButton.style.backgroundColor}
// // // //                         onChange={(e) => handleCtaStyleChange('backgroundColor', e.target.value)}
// // // //                         className="flex-1 p-2 border border-gray-300 rounded-md"
// // // //                       />
// // // //                     </div>
// // // //                   </div>
                  
// // // //                   <div className="mb-4">
// // // //                     <label className="block text-sm font-medium text-gray-700 mb-2">Kolor tekstu</label>
// // // //                     <div className="flex items-center gap-2">
// // // //                       <input
// // // //                         type="color"
// // // //                         value={heroData.ctaButton.style.color}
// // // //                         onChange={(e) => handleCtaStyleChange('color', e.target.value)}
// // // //                         className="w-10 h-10 rounded border border-gray-300"
// // // //                       />
// // // //                       <input
// // // //                         type="text"
// // // //                         value={heroData.ctaButton.style.color}
// // // //                         onChange={(e) => handleCtaStyleChange('color', e.target.value)}
// // // //                         className="flex-1 p-2 border border-gray-300 rounded-md"
// // // //                       />
// // // //                     </div>
// // // //                   </div>

// // // //                   <div className="mt-4 p-3 bg-blue-50 rounded-md">
// // // //                     <p className="text-sm text-blue-700">
// // // //                       <strong>Informacja:</strong> Przycisk będzie zawsze kierował do sekcji kontaktowej (#contact).
// // // //                     </p>
// // // //                   </div>
// // // //                 </>
// // // //               )}
// // // //             </div>
            
// // // //             {/* Zapisywanie */}
// // // //             <div className="flex justify-end">
// // // //               <button
// // // //                 onClick={saveData}
// // // //                 className="flex items-center gap-2 bg-green-500 hover:bg-green-600 text-white font-medium py-2 px-4 rounded-md"
// // // //               >
// // // //                 <FaSave /> Zapisz zmiany
// // // //               </button>
// // // //             </div>
// // // //           </div>
          
// // // //           {/* Podgląd */}
// // // //           <div className="p-4 border border-gray-200 rounded-md">
// // // //             <h2 className="text-lg font-semibold mb-3">Podgląd sekcji Hero</h2>
// // // //             <div className="border rounded-md overflow-hidden">
// // // //               <section 
// // // //                 className="h-96 bg-cover bg-center flex items-center justify-center text-white relative"
// // // //                 style={{ backgroundImage: `url('${heroData.backgroundImage}')` }}
// // // //               >
// // // //                 {heroData.overlay.enabled && (
// // // //                   <div className={`absolute inset-0 ${heroData.overlay.gradient}`} />
// // // //                 )}
// // // //                 <div className="relative z-10 text-center px-4">
// // // //                   <h1 
// // // //                     className={`${getTailwindClasses(heroData.titleStyle, 'title')} mb-4 drop-shadow-lg`}
// // // //                     style={{ color: heroData.titleStyle.color }}
// // // //                   >
// // // //                     {heroData.title}
// // // //                   </h1>
// // // //                   <p 
// // // //                     className={`${getTailwindClasses(heroData.subtitleStyle, 'subtitle')} drop-shadow-lg`}
// // // //                     style={{ color: heroData.subtitleStyle.color }}
// // // //                   >
// // // //                     {heroData.subtitle}
// // // //                   </p>
                  
// // // //                   {heroData.ctaButton.enabled && (
// // // //                     <div className="mt-6">
// // // //                       <a
// // // //                         href="./Contact"
// // // //                         className="inline-block font-medium transition-colors hover:opacity-90"
// // // //                         style={heroData.ctaButton.style}
// // // //                       >
// // // //                         {heroData.ctaButton.text}
// // // //                       </a>
// // // //                     </div>
// // // //                   )}
// // // //                 </div>
// // // //               </section>
// // // //             </div>
            
// // // //             <div className="mt-4 p-3 bg-gray-50 rounded-md">
// // // //               <h3 className="font-medium mb-2">Informacje</h3>
// // // //               <p className="text-sm text-gray-600">
// // // //                 Sekcja Hero jest pierwszą rzeczą, którą widzą użytkownicy na stronie. 
// // // //                 Upewnij się, że tekst jest czytelny na tle obrazu, a przycisk CTA jest wyraźny i zachęca do działania.
// // // //                 Przycisk CTA zawsze kieruje do sekcji kontaktowej (#contact).
// // // //               </p>
// // // //             </div>
// // // //           </div>
// // // //         </div>
// // // //       </div>
// // // //     </div>
// // // //   );
// // // // };

// // // // export default HeroAdmin;

// // // // import React, { useState, useEffect } from 'react';
// // // // import { FaSave, FaUpload } from 'react-icons/fa';

// // // // const AdminHeroPanel = () => {
// // // //   // Stan dla danych hero
// // // //   const [heroData, setHeroData] = useState({
// // // //     backgroundImage: "/images/hero.jpg",
// // // //     title: "Kolorowe Domki",
// // // //     subtitle: "Idealne miejsce nad morzem dla rodzin z dziećmi",
// // // //     titleStyle: {
// // // //       fontSize: "5xl",
// // // //       fontWeight: "extrabold",
// // // //       color: "#ffffff",
// // // //       textShadow: "0 2px 4px rgba(0,0,0,0.5)"
// // // //     },
// // // //     subtitleStyle: {
// // // //       fontSize: "xl",
// // // //       fontWeight: "light",
// // // //       color: "#ffffff",
// // // //       textShadow: "0 2px 4px rgba(0,0,0,0.5)"
// // // //     },
// // // //     overlay: {
// // // //       enabled: true,
// // // //       gradient: "bg-gradient-to-br from-black/60 to-black/30"
// // // //     }
// // // //   });

// // // //   const [message, setMessage] = useState("");
// // // //   const [imageUploading, setImageUploading] = useState(false);
// // // //   const [fontSizes] = useState([
// // // //     { value: "sm", label: "Mały" },
// // // //     { value: "base", label: "Normalny" },
// // // //     { value: "lg", label: "Duży" },
// // // //     { value: "xl", label: "Bardzo duży" },
// // // //     { value: "2xl", label: "X-Large" },
// // // //     { value: "3xl", label: "2X-Large" },
// // // //     { value: "4xl", label: "3X-Large" },
// // // //     { value: "5xl", label: "4X-Large" },
// // // //     { value: "6xl", label: "5X-Large" },
// // // //     { value: "7xl", label: "6X-Large" }
// // // //   ]);

// // // //   // Załaduj dane z localStorage przy starcie
// // // //   useEffect(() => {
// // // //     const savedData = localStorage.getItem('heroData');
// // // //     if (savedData) {
// // // //       setHeroData(JSON.parse(savedData));
// // // //     }
// // // //   }, []);

// // // //   const saveData = () => {
// // // //     localStorage.setItem('heroData', JSON.stringify(heroData));
// // // //     setMessage("Zmiany zapisane pomyślnie!");
// // // //     setTimeout(() => setMessage(""), 3000);
// // // //   };

// // // //   const handleImageUpload = (e) => {
// // // //     const file = e.target.files[0];
// // // //     if (file) {
// // // //       setImageUploading(true);
      
// // // //       // Symulacja procesu uploadu
// // // //       setTimeout(() => {
// // // //         const reader = new FileReader();
// // // //         reader.onload = (event) => {
// // // //           const newImageUrl = event.target.result;
// // // //           setHeroData({
// // // //             ...heroData,
// // // //             backgroundImage: newImageUrl
// // // //           });
// // // //           setImageUploading(false);
// // // //         };
// // // //         reader.readAsDataURL(file);
// // // //       }, 1000);
// // // //     }
// // // //   };

// // // //   const handleTitleChange = (e) => {
// // // //     setHeroData({ ...heroData, title: e.target.value });
// // // //   };

// // // //   const handleSubtitleChange = (e) => {
// // // //     setHeroData({ ...heroData, subtitle: e.target.value });
// // // //   };

// // // //   const handleTitleStyleChange = (property, value) => {
// // // //     setHeroData({ 
// // // //       ...heroData, 
// // // //       titleStyle: { ...heroData.titleStyle, [property]: value } 
// // // //     });
// // // //   };

// // // //   const handleSubtitleStyleChange = (property, value) => {
// // // //     setHeroData({ 
// // // //       ...heroData, 
// // // //       subtitleStyle: { ...heroData.subtitleStyle, [property]: value } 
// // // //     });
// // // //   };

// // // //   const handleOverlayChange = (enabled) => {
// // // //     setHeroData({ 
// // // //       ...heroData, 
// // // //       overlay: { ...heroData.overlay, enabled } 
// // // //     });
// // // //   };

// // // //   const handleGradientChange = (e) => {
// // // //     setHeroData({ 
// // // //       ...heroData, 
// // // //       overlay: { ...heroData.overlay, gradient: e.target.value } 
// // // //     });
// // // //   };

// // // //   // Funkcja do konwersji stylów na klasy Tailwind
// // // //   const getTailwindClasses = (style, type) => {
// // // //     const classes = [];
    
// // // //     if (type === 'title') {
// // // //       classes.push(`text-${style.fontSize}`);
// // // //       classes.push(`font-${style.fontWeight}`);
// // // //     } else if (type === 'subtitle') {
// // // //       classes.push(`text-${style.fontSize}`);
// // // //       classes.push(`font-${style.fontWeight}`);
// // // //     }
    
// // // //     return classes.join(' ');
// // // //   };

// // // //   // Predefiniowane gradienty do wyboru
// // // //   const gradients = [
// // // //     { value: "bg-gradient-to-br from-black/60 to-black/30", label: "Ciemny (domyślny)" },
// // // //     { value: "bg-gradient-to-br from-blue-900/60 to-blue-500/30", label: "Niebieski" },
// // // //     { value: "bg-gradient-to-br from-purple-900/60 to-purple-500/30", label: "Fioletowy" },
// // // //     { value: "bg-gradient-to-br from-green-900/60 to-green-500/30", label: "Zielony" },
// // // //     { value: "bg-gradient-to-br from-red-900/60 to-red-500/30", label: "Czerwony" },
// // // //     { value: "bg-gradient-to-br from-yellow-900/60 to-yellow-500/30", label: "Żółty" },
// // // //     { value: "bg-gradient-to-br from-pink-900/60 to-pink-500/30", label: "Różowy" },
// // // //     { value: "none", label: "Brak overlay" }
// // // //   ];

// // // //   return (
// // // //     <div className="min-h-screen bg-gray-100 p-6">
// // // //       <div className="max-w-5xl mx-auto bg-white rounded-lg shadow-md p-6">
// // // //         <h1 className="text-2xl font-bold mb-6 text-gray-800">Panel Administracyjny - Sekcja Hero</h1>
        
// // // //         {message && (
// // // //           <div className="mb-4 p-3 bg-green-100 text-green-700 rounded">
// // // //             {message}
// // // //           </div>
// // // //         )}
        
// // // //         <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
// // // //           {/* Panel edycji */}
// // // //           <div className="space-y-6">
// // // //             {/* Tło */}
// // // //             <div className="p-4 border border-gray-200 rounded-md">
// // // //               <h2 className="text-lg font-semibold mb-3">Tło</h2>
              
// // // //               <div className="mb-4">
// // // //                 <label className="block text-sm font-medium text-gray-700 mb-2">Zdjęcie tła</label>
// // // //                 <div className="flex items-center gap-4">
// // // //                   <div className="w-20 h-20 bg-gray-200 rounded-md overflow-hidden">
// // // //                     <img 
// // // //                       src={heroData.backgroundImage} 
// // // //                       alt="Podgląd tła" 
// // // //                       className="w-full h-full object-cover"
// // // //                     />
// // // //                   </div>
// // // //                   <label className="flex flex-col items-center justify-center w-full h-32 border-2 border-dashed border-gray-300 rounded-md cursor-pointer bg-gray-50 hover:bg-gray-100">
// // // //                     {imageUploading ? (
// // // //                       <div className="flex flex-col items-center justify-center">
// // // //                         <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-blue-500 mb-2"></div>
// // // //                         <span className="text-sm">Przesyłanie...</span>
// // // //                       </div>
// // // //                     ) : (
// // // //                       <>
// // // //                         <FaUpload className="w-8 h-8 text-gray-500 mb-2" />
// // // //                         <p className="text-sm text-gray-500 text-center">
// // // //                           <span className="font-semibold">Kliknij aby przesłać</span><br />
// // // //                           <span className="text-xs">PNG, JPG (max. 5MB)</span>
// // // //                         </p>
// // // //                         <input 
// // // //                           type="file" 
// // // //                           className="hidden" 
// // // //                           onChange={handleImageUpload} 
// // // //                           accept="image/*" 
// // // //                         />
// // // //                       </>
// // // //                     )}
// // // //                   </label>
// // // //                 </div>
// // // //               </div>
              
// // // //               <div className="mb-4">
// // // //                 <label className="block text-sm font-medium text-gray-700 mb-2">Overlay</label>
// // // //                 <div className="flex items-center gap-2">
// // // //                   <input
// // // //                     type="checkbox"
// // // //                     checked={heroData.overlay.enabled}
// // // //                     onChange={(e) => handleOverlayChange(e.target.checked)}
// // // //                     className="rounded border-gray-300 text-blue-600 focus:ring-blue-500"
// // // //                   />
// // // //                   <span>Włącz overlay</span>
// // // //                 </div>
// // // //               </div>
              
// // // //               {heroData.overlay.enabled && (
// // // //                 <div className="mb-4">
// // // //                   <label className="block text-sm font-medium text-gray-700 mb-2">Gradient overlay</label>
// // // //                   <select
// // // //                     value={heroData.overlay.gradient}
// // // //                     onChange={handleGradientChange}
// // // //                     className="w-full p-2 border border-gray-300 rounded-md"
// // // //                   >
// // // //                     {gradients.map((gradient) => (
// // // //                       <option key={gradient.value} value={gradient.value}>
// // // //                         {gradient.label}
// // // //                       </option>
// // // //                     ))}
// // // //                   </select>
// // // //                 </div>
// // // //               )}
// // // //             </div>
            
// // // //             {/* Tytuł */}
// // // //             <div className="p-4 border border-gray-200 rounded-md">
// // // //               <h2 className="text-lg font-semibold mb-3">Tytuł</h2>
              
// // // //               <div className="mb-4">
// // // //                 <label className="block text-sm font-medium text-gray-700 mb-2">Tekst tytułu</label>
// // // //                 <input
// // // //                   type="text"
// // // //                   value={heroData.title}
// // // //                   onChange={handleTitleChange}
// // // //                   className="w-full p-3 border border-gray-300 rounded-md"
// // // //                 />
// // // //               </div>
              
// // // //               <div className="grid grid-cols-2 gap-4 mb-4">
// // // //                 <div>
// // // //                   <label className="block text-sm font-medium text-gray-700 mb-2">Rozmiar czcionki</label>
// // // //                   <select
// // // //                     value={heroData.titleStyle.fontSize}
// // // //                     onChange={(e) => handleTitleStyleChange('fontSize', e.target.value)}
// // // //                     className="w-full p-2 border border-gray-300 rounded-md"
// // // //                   >
// // // //                     {fontSizes.map((size) => (
// // // //                       <option key={size.value} value={size.value}>
// // // //                         {size.label}
// // // //                       </option>
// // // //                     ))}
// // // //                   </select>
// // // //                 </div>
                
// // // //                 <div>
// // // //                   <label className="block text-sm font-medium text-gray-700 mb-2">Grubość czcionki</label>
// // // //                   <select
// // // //                     value={heroData.titleStyle.fontWeight}
// // // //                     onChange={(e) => handleTitleStyleChange('fontWeight', e.target.value)}
// // // //                     className="w-full p-2 border border-gray-300 rounded-md"
// // // //                   >
// // // //                     <option value="light">Light</option>
// // // //                     <option value="normal">Normal</option>
// // // //                     <option value="medium">Medium</option>
// // // //                     <option value="semibold">Semibold</option>
// // // //                     <option value="bold">Bold</option>
// // // //                     <option value="extrabold">Extrabold</option>
// // // //                   </select>
// // // //                 </div>
// // // //               </div>
              
// // // //               <div className="mb-4">
// // // //                 <label className="block text-sm font-medium text-gray-700 mb-2">Kolor tekstu</label>
// // // //                 <div className="flex items-center gap-2">
// // // //                   <input
// // // //                     type="color"
// // // //                     value={heroData.titleStyle.color}
// // // //                     onChange={(e) => handleTitleStyleChange('color', e.target.value)}
// // // //                     className="w-10 h-10 rounded border border-gray-300"
// // // //                   />
// // // //                   <input
// // // //                     type="text"
// // // //                     value={heroData.titleStyle.color}
// // // //                     onChange={(e) => handleTitleStyleChange('color', e.target.value)}
// // // //                     className="flex-1 p-2 border border-gray-300 rounded-md"
// // // //                   />
// // // //                 </div>
// // // //               </div>
// // // //             </div>
            
// // // //             {/* Podtytuł */}
// // // //             <div className="p-4 border border-gray-200 rounded-md">
// // // //               <h2 className="text-lg font-semibold mb-3">Podtytuł</h2>
              
// // // //               <div className="mb-4">
// // // //                 <label className="block text-sm font-medium text-gray-700 mb-2">Tekst podtytułu</label>
// // // //                 <input
// // // //                   type="text"
// // // //                   value={heroData.subtitle}
// // // //                   onChange={handleSubtitleChange}
// // // //                   className="w-full p-3 border border-gray-300 rounded-md"
// // // //                 />
// // // //               </div>
              
// // // //               <div className="grid grid-cols-2 gap-4 mb-4">
// // // //                 <div>
// // // //                   <label className="block text-sm font-medium text-gray-700 mb-2">Rozmiar czcionki</label>
// // // //                   <select
// // // //                     value={heroData.subtitleStyle.fontSize}
// // // //                     onChange={(e) => handleSubtitleStyleChange('fontSize', e.target.value)}
// // // //                     className="w-full p-2 border border-gray-300 rounded-md"
// // // //                   >
// // // //                     {fontSizes.map((size) => (
// // // //                       <option key={size.value} value={size.value}>
// // // //                         {size.label}
// // // //                       </option>
// // // //                     ))}
// // // //                   </select>
// // // //                 </div>
                
// // // //                 <div>
// // // //                   <label className="block text-sm font-medium text-gray-700 mb-2">Grubość czcionki</label>
// // // //                   <select
// // // //                     value={heroData.subtitleStyle.fontWeight}
// // // //                     onChange={(e) => handleSubtitleStyleChange('fontWeight', e.target.value)}
// // // //                     className="w-full p-2 border border-gray-300 rounded-md"
// // // //                   >
// // // //                     <option value="light">Light</option>
// // // //                     <option value="normal">Normal</option>
// // // //                     <option value="medium">Medium</option>
// // // //                     <option value="semibold">Semibold</option>
// // // //                     <option value="bold">Bold</option>
// // // //                     <option value="extrabold">Extrabold</option>
// // // //                   </select>
// // // //                 </div>
// // // //               </div>
              
// // // //               <div className="mb-4">
// // // //                 <label className="block text-sm font-medium text-gray-700 mb-2">Kolor tekstu</label>
// // // //                 <div className="flex items-center gap-2">
// // // //                   <input
// // // //                     type="color"
// // // //                     value={heroData.subtitleStyle.color}
// // // //                     onChange={(e) => handleSubtitleStyleChange('color', e.target.value)}
// // // //                     className="w-10 h-10 rounded border border-gray-300"
// // // //                   />
// // // //                   <input
// // // //                     type="text"
// // // //                     value={heroData.subtitleStyle.color}
// // // //                     onChange={(e) => handleSubtitleStyleChange('color', e.target.value)}
// // // //                     className="flex-1 p-2 border border-gray-300 rounded-md"
// // // //                   />
// // // //                 </div>
// // // //               </div>
// // // //             </div>
            
// // // //             {/* Zapisywanie */}
// // // //             <div className="flex justify-end">
// // // //               <button
// // // //                 onClick={saveData}
// // // //                 className="flex items-center gap-2 bg-green-500 hover:bg-green-600 text-white font-medium py-2 px-4 rounded-md"
// // // //               >
// // // //                 <FaSave /> Zapisz zmiany
// // // //               </button>
// // // //             </div>
// // // //           </div>
          
// // // //           {/* Podgląd */}
// // // //           <div className="p-4 border border-gray-200 rounded-md">
// // // //             <h2 className="text-lg font-semibold mb-3">Podgląd sekcji Hero</h2>
// // // //             <div className="border rounded-md overflow-hidden">
// // // //               <section 
// // // //                 className="h-96 bg-cover bg-center flex items-center justify-center text-white relative"
// // // //                 style={{ backgroundImage: `url('${heroData.backgroundImage}')` }}
// // // //               >
// // // //                 {heroData.overlay.enabled && (
// // // //                   <div className={`absolute inset-0 ${heroData.overlay.gradient}`} />
// // // //                 )}
// // // //                 <div className="relative z-10 text-center px-4">
// // // //                   <h1 
// // // //                     className={`${getTailwindClasses(heroData.titleStyle, 'title')} mb-4 drop-shadow-lg`}
// // // //                     style={{ color: heroData.titleStyle.color }}
// // // //                   >
// // // //                     {heroData.title}
// // // //                   </h1>
// // // //                   <p 
// // // //                     className={`${getTailwindClasses(heroData.subtitleStyle, 'subtitle')} drop-shadow-lg`}
// // // //                     style={{ color: heroData.subtitleStyle.color }}
// // // //                   >
// // // //                     {heroData.subtitle}
// // // //                   </p>
// // // //                 </div>
// // // //               </section>
// // // //             </div>
            
// // // //             <div className="mt-4 p-3 bg-gray-50 rounded-md">
// // // //               <h3 className="font-medium mb-2">Informacje</h3>
// // // //               <p className="text-sm text-gray-600">
// // // //                 Sekcja Hero jest pierwszą rzeczą, którą widzą użytkownicy na stronie. 
// // // //                 Upewnij się, że tekst jest czytelny na tle obrazu.
// // // //               </p>
// // // //             </div>
// // // //           </div>
// // // //         </div>
// // // //       </div>
// // // //     </div>
// // // //   );
// // // // };

// // // // export default AdminHeroPanel;



// // // import React, { useState, useEffect } from 'react';
// // // import { FaSave, FaUpload, FaArrowUp, FaArrowDown, FaTrash, FaPlus } from 'react-icons/fa';

// // // const AdminHeroPanel = () => {
// // //   // Domyślne dane
// // //   const defaultHeroData = {
// // //     images: [
// // //       { id: 1, url: "/images/hero1.jpg", order: 0 },
// // //       { id: 2, url: "/images/hero2.jpg", order: 1 },
// // //       { id: 3, url: "/images/hero3.jpg", order: 2 },
// // //       { id: 4, url: "/images/hero4.jpg", order: 3 },
// // //       { id: 5, url: "/images/hero5.jpg", order: 4 }
// // //     ],
// // //     title: "Kolorowe Domki",
// // //     subtitle: "Idealne miejsce nad morzem dla rodzin z dziećmi",
// // //     titleStyle: {
// // //       fontSize: "5xl",
// // //       fontWeight: "extrabold",
// // //       color: "#ffffff",
// // //       textShadow: "0 2px 4px rgba(0,0,0,0.5)"
// // //     },
// // //     subtitleStyle: {
// // //       fontSize: "xl",
// // //       fontWeight: "light",
// // //       color: "#ffffff",
// // //       textShadow: "0 2px 4px rgba(0,0,0,0.5)"
// // //     },
// // //     overlay: {
// // //       enabled: true,
// // //       gradient: "bg-gradient-to-br from-black/60 to-black/30"
// // //     },
// // //     slideInterval: 5000
// // //   };

// // //   const [heroData, setHeroData] = useState(defaultHeroData);
// // //   const [message, setMessage] = useState("");
// // //   const [imageUploading, setImageUploading] = useState(false);
// // //   const [currentSlideIndex, setCurrentSlideIndex] = useState(0);
  
// // //   const fontSizes = [
// // //     { value: "sm", label: "Mały" },
// // //     { value: "base", label: "Normalny" },
// // //     { value: "lg", label: "Duży" },
// // //     { value: "xl", label: "Bardzo duży" },
// // //     { value: "2xl", label: "X-Large" },
// // //     { value: "3xl", label: "2X-Large" },
// // //     { value: "4xl", label: "3X-Large" },
// // //     { value: "5xl", label: "4X-Large" },
// // //     { value: "6xl", label: "5X-Large" },
// // //     { value: "7xl", label: "6X-Large" }
// // //   ];

// // //   const gradients = [
// // //     { value: "bg-gradient-to-br from-black/60 to-black/30", label: "Ciemny (domyślny)" },
// // //     { value: "bg-gradient-to-br from-blue-900/60 to-blue-500/30", label: "Niebieski" },
// // //     { value: "bg-gradient-to-br from-purple-900/60 to-purple-500/30", label: "Fioletowy" },
// // //     { value: "bg-gradient-to-br from-green-900/60 to-green-500/30", label: "Zielony" },
// // //     { value: "bg-gradient-to-br from-red-900/60 to-red-500/30", label: "Czerwony" },
// // //     { value: "bg-gradient-to-br from-yellow-900/60 to-yellow-500/30", label: "Żółty" },
// // //     { value: "bg-gradient-to-br from-pink-900/60 to-pink-500/30", label: "Różowy" },
// // //     { value: "none", label: "Brak overlay" }
// // //   ];

// // //   // Załaduj dane z localStorage
// // //   useEffect(() => {
// // //     const savedData = localStorage.getItem('heroData');
// // //     if (savedData) {
// // //       try {
// // //         const parsedData = JSON.parse(savedData);
// // //         setHeroData(parsedData);
// // //       } catch (error) {
// // //         console.error('Błąd parsowania danych:', error);
// // //         setHeroData(defaultHeroData);
// // //       }
// // //     }
// // //   }, []);

// // //   // Symulacja pokazu slajdów w podglądzie
// // //   useEffect(() => {
// // //     if (heroData.images.length > 1) {
// // //       const interval = setInterval(() => {
// // //         setCurrentSlideIndex((prevIndex) => 
// // //           (prevIndex + 1) % heroData.images.length
// // //         );
// // //       }, heroData.slideInterval);

// // //       return () => clearInterval(interval);
// // //     }
// // //   }, [heroData.images.length, heroData.slideInterval]);

// // //   const saveData = () => {
// // //     localStorage.setItem('heroData', JSON.stringify(heroData));
// // //     setMessage("Zmiany zapisane pomyślnie!");
// // //     setTimeout(() => setMessage(""), 3000);
// // //   };

// // //   const handleImageUpload = (e, index = null) => {
// // //     const file = e.target.files[0];
// // //     if (file) {
// // //       setImageUploading(true);
      
// // //       setTimeout(() => {
// // //         const reader = new FileReader();
// // //         reader.onload = (event) => {
// // //           const newImageUrl = event.target.result;
          
// // //           if (index !== null) {
// // //             // Zamień istniejący obraz
// // //             const updatedImages = [...heroData.images];
// // //             updatedImages[index] = { ...updatedImages[index], url: newImageUrl };
// // //             setHeroData({ ...heroData, images: updatedImages });
// // //           } else if (heroData.images.length < 10) {
// // //             // Dodaj nowy obraz
// // //             const newImage = {
// // //               id: Date.now(),
// // //               url: newImageUrl,
// // //               order: heroData.images.length
// // //             };
// // //             setHeroData({ ...heroData, images: [...heroData.images, newImage] });
// // //           }
          
// // //           setImageUploading(false);
// // //         };
// // //         reader.readAsDataURL(file);
// // //       }, 1000);
// // //     }
// // //   };

// // //   const moveImage = (index, direction) => {
// // //     const updatedImages = [...heroData.images];
    
// // //     if (direction === 'up' && index > 0) {
// // //       [updatedImages[index], updatedImages[index - 1]] = 
// // //       [updatedImages[index - 1], updatedImages[index]];
// // //     } else if (direction === 'down' && index < updatedImages.length - 1) {
// // //       [updatedImages[index], updatedImages[index + 1]] = 
// // //       [updatedImages[index + 1], updatedImages[index]];
// // //     }
    
// // //     const reorderedImages = updatedImages.map((img, idx) => ({
// // //       ...img,
// // //       order: idx
// // //     }));
    
// // //     setHeroData({ ...heroData, images: reorderedImages });
// // //   };

// // //   const removeImage = (index) => {
// // //     if (heroData.images.length > 1) {
// // //       const updatedImages = heroData.images.filter((_, i) => i !== index);
// // //       setHeroData({ ...heroData, images: updatedImages });
      
// // //       // Reset current slide index if needed
// // //       if (currentSlideIndex >= updatedImages.length) {
// // //         setCurrentSlideIndex(0);
// // //       }
// // //     }
// // //   };

// // //   const handleInputChange = (field, value) => {
// // //     setHeroData(prev => ({ ...prev, [field]: value }));
// // //   };

// // //   const handleStyleChange = (section, property, value) => {
// // //     setHeroData(prev => ({
// // //       ...prev,
// // //       [section]: {
// // //         ...prev[section],
// // //         [property]: value
// // //       }
// // //     }));
// // //   };

// // //   const handleOverlayChange = (enabled) => {
// // //     setHeroData(prev => ({
// // //       ...prev,
// // //       overlay: { ...prev.overlay, enabled }
// // //     }));
// // //   };

// // //   const getTailwindClasses = (style, type) => {
// // //     const classes = [];
// // //     if (type === 'title') {
// // //       classes.push(`text-${style.fontSize}`);
// // //       classes.push(`font-${style.fontWeight}`);
// // //     } else if (type === 'subtitle') {
// // //       classes.push(`text-${style.fontSize}`);
// // //       classes.push(`font-${style.fontWeight}`);
// // //     }
// // //     return classes.join(' ');
// // //   };

// // //   return (
// // //     <div className="min-h-screen bg-gray-100 p-6">
// // //       <div className="max-w-6xl mx-auto bg-white rounded-lg shadow-md p-6">
// // //         <h1 className="text-2xl font-bold mb-6 text-gray-800">Panel Administracyjny - Sekcja Hero</h1>
        
// // //         {message && (
// // //           <div className="mb-4 p-3 bg-green-100 text-green-700 rounded">
// // //             {message}
// // //           </div>
// // //         )}
        
// // //         <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
// // //           {/* Panel edycji */}
// // //           <div className="space-y-6">
// // //             {/* Zarządzanie zdjęciami */}
// // //             <div className="p-4 border border-gray-200 rounded-md">
// // //               <h2 className="text-lg font-semibold mb-3">Pokaz Slajdów</h2>
              
// // //               <div className="mb-4">
// // //                 <label className="block text-sm font-medium text-gray-700 mb-2">
// // //                   Interwał zmiany slajdów (ms)
// // //                 </label>
// // //                 <input
// // //                   type="number"
// // //                   value={heroData.slideInterval}
// // //                   onChange={(e) => handleInputChange('slideInterval', parseInt(e.target.value))}
// // //                   min="1000"
// // //                   step="1000"
// // //                   className="w-full p-2 border border-gray-300 rounded-md"
// // //                 />
// // //                 <p className="text-xs text-gray-500 mt-1">
// // //                   Czas w milisekundach pomiędzy zmianami slajdów (1000ms = 1s)
// // //                 </p>
// // //               </div>
              
// // //               <div className="mb-4">
// // //                 <label className="block text-sm font-medium text-gray-700 mb-2">
// // //                   Zarządzanie zdjęciami ({heroData.images.length}/10)
// // //                 </label>
                
// // //                 <div className="space-y-3">
// // //                   {heroData.images.map((image, index) => (
// // //                     <div key={image.id} className="flex items-center gap-3 p-3 border border-gray-200 rounded-md">
// // //                       <div className="w-16 h-16 bg-gray-200 rounded-md overflow-hidden flex-shrink-0">
// // //                         <img 
// // //                           src={image.url} 
// // //                           alt={`Slajd ${index + 1}`} 
// // //                           className="w-full h-full object-cover"
// // //                         />
// // //                       </div>
                      
// // //                       <div className="flex-1">
// // //                         <p className="text-sm font-medium">Slajd {index + 1}</p>
// // //                         <div className="flex gap-1 mt-2">
// // //                           <button
// // //                             onClick={() => moveImage(index, 'up')}
// // //                             disabled={index === 0}
// // //                             className={`p-1 rounded ${index === 0 ? 'bg-gray-200 text-gray-400' : 'bg-gray-200 hover:bg-gray-300'}`}
// // //                           >
// // //                             <FaArrowUp size={12} />
// // //                           </button>
// // //                           <button
// // //                             onClick={() => moveImage(index, 'down')}
// // //                             disabled={index === heroData.images.length - 1}
// // //                             className={`p-1 rounded ${index === heroData.images.length - 1 ? 'bg-gray-200 text-gray-400' : 'bg-gray-200 hover:bg-gray-300'}`}
// // //                           >
// // //                             <FaArrowDown size={12} />
// // //                           </button>
// // //                           <button
// // //                             onClick={() => removeImage(index)}
// // //                             disabled={heroData.images.length <= 1}
// // //                             className={`p-1 rounded ${heroData.images.length <= 1 ? 'bg-gray-200 text-gray-400' : 'bg-red-100 hover:bg-red-200 text-red-600'}`}
// // //                           >
// // //                             <FaTrash size={12} />
// // //                           </button>
// // //                         </div>
// // //                       </div>
                      
// // //                       <label className="flex flex-col items-center justify-center w-24 h-16 border border-dashed border-gray-300 rounded-md cursor-pointer bg-gray-50 hover:bg-gray-100 text-center">
// // //                         {imageUploading ? (
// // //                           <div className="flex flex-col items-center justify-center">
// // //                             <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-blue-500 mb-1"></div>
// // //                             <span className="text-xs">Przesyłanie...</span>
// // //                           </div>
// // //                         ) : (
// // //                           <>
// // //                             <FaUpload className="w-4 h-4 text-gray-500 mb-1" />
// // //                             <p className="text-xs text-gray-500">Zmień</p>
// // //                             <input 
// // //                               type="file" 
// // //                               className="hidden" 
// // //                               onChange={(e) => handleImageUpload(e, index)} 
// // //                               accept="image/*" 
// // //                             />
// // //                           </>
// // //                         )}
// // //                       </label>
// // //                     </div>
// // //                   ))}
// // //                 </div>
                
// // //                 {heroData.images.length < 10 && (
// // //                   <div className="mt-3">
// // //                     <label className="flex flex-col items-center justify-center w-full h-20 border-2 border-dashed border-gray-300 rounded-md cursor-pointer bg-gray-50 hover:bg-gray-100">
// // //                       {imageUploading ? (
// // //                         <div className="flex flex-col items-center justify-center">
// // //                           <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-blue-500 mb-2"></div>
// // //                           <span className="text-sm">Przesyłanie...</span>
// // //                         </div>
// // //                       ) : (
// // //                         <>
// // //                           <FaPlus className="w-6 h-6 text-gray-500 mb-2" />
// // //                           <p className="text-sm text-gray-500 text-center">
// // //                             <span className="font-semibold">Dodaj nowe zdjęcie</span><br />
// // //                             <span className="text-xs">PNG, JPG (max. 5MB)</span>
// // //                           </p>
// // //                           <input 
// // //                             type="file" 
// // //                             className="hidden" 
// // //                             onChange={handleImageUpload} 
// // //                             accept="image/*" 
// // //                           />
// // //                         </>
// // //                       )}
// // //                     </label>
// // //                   </div>
// // //                 )}
// // //               </div>
              
// // //               <div className="mb-4">
// // //                 <label className="block text-sm font-medium text-gray-700 mb-2">Overlay</label>
// // //                 <div className="flex items-center gap-2">
// // //                   <input
// // //                     type="checkbox"
// // //                     checked={heroData.overlay.enabled}
// // //                     onChange={(e) => handleOverlayChange(e.target.checked)}
// // //                     className="rounded border-gray-300 text-blue-600 focus:ring-blue-500"
// // //                   />
// // //                   <span>Włącz overlay</span>
// // //                 </div>
// // //               </div>
              
// // //               {heroData.overlay.enabled && (
// // //                 <div className="mb-4">
// // //                   <label className="block text-sm font-medium text-gray-700 mb-2">Gradient overlay</label>
// // //                   <select
// // //                     value={heroData.overlay.gradient}
// // //                     onChange={(e) => handleStyleChange('overlay', 'gradient', e.target.value)}
// // //                     className="w-full p-2 border border-gray-300 rounded-md"
// // //                   >
// // //                     {gradients.map((gradient) => (
// // //                       <option key={gradient.value} value={gradient.value}>
// // //                         {gradient.label}
// // //                       </option>
// // //                     ))}
// // //                   </select>
// // //                 </div>
// // //               )}
// // //             </div>

// // //             {/* Tytuł */}
// // //             <div className="p-4 border border-gray-200 rounded-md">
// // //               <h2 className="text-lg font-semibold mb-3">Tytuł</h2>
              
// // //               <div className="mb-4">
// // //                 <label className="block text-sm font-medium text-gray-700 mb-2">Tekst tytułu</label>
// // //                 <input
// // //                   type="text"
// // //                   value={heroData.title}
// // //                   onChange={(e) => handleInputChange('title', e.target.value)}
// // //                   className="w-full p-3 border border-gray-300 rounded-md"
// // //                 />
// // //               </div>
              
// // //               <div className="grid grid-cols-2 gap-4 mb-4">
// // //                 <div>
// // //                   <label className="block text-sm font-medium text-gray-700 mb-2">Rozmiar czcionki</label>
// // //                   <select
// // //                     value={heroData.titleStyle.fontSize}
// // //                     onChange={(e) => handleStyleChange('titleStyle', 'fontSize', e.target.value)}
// // //                     className="w-full p-2 border border-gray-300 rounded-md"
// // //                   >
// // //                     {fontSizes.map((size) => (
// // //                       <option key={size.value} value={size.value}>
// // //                         {size.label}
// // //                       </option>
// // //                     ))}
// // //                   </select>
// // //                 </div>
                
// // //                 <div>
// // //                   <label className="block text-sm font-medium text-gray-700 mb-2">Grubość czcionki</label>
// // //                   <select
// // //                     value={heroData.titleStyle.fontWeight}
// // //                     onChange={(e) => handleStyleChange('titleStyle', 'fontWeight', e.target.value)}
// // //                     className="w-full p-2 border border-gray-300 rounded-md"
// // //                   >
// // //                     <option value="light">Light</option>
// // //                     <option value="normal">Normal</option>
// // //                     <option value="medium">Medium</option>
// // //                     <option value="semibold">Semibold</option>
// // //                     <option value="bold">Bold</option>
// // //                     <option value="extrabold">Extrabold</option>
// // //                   </select>
// // //                 </div>
// // //               </div>
              
// // //               <div className="mb-4">
// // //                 <label className="block text-sm font-medium text-gray-700 mb-2">Kolor tekstu</label>
// // //                 <div className="flex items-center gap-2">
// // //                   <input
// // //                     type="color"
// // //                     value={heroData.titleStyle.color}
// // //                     onChange={(e) => handleStyleChange('titleStyle', 'color', e.target.value)}
// // //                     className="w-10 h-10 rounded border border-gray-300"
// // //                   />
// // //                   <input
// // //                     type="text"
// // //                     value={heroData.titleStyle.color}
// // //                     onChange={(e) => handleStyleChange('titleStyle', 'color', e.target.value)}
// // //                     className="flex-1 p-2 border border-gray-300 rounded-md"
// // //                   />
// // //                 </div>
// // //               </div>
// // //             </div>

// // //             {/* Podtytuł */}
// // // <div className="p-4 border border-gray-200 rounded-md">
// // //   <h2 className="text-lg font-semibold mb-3">Podtytuł</h2>
  
// // //   <div className="mb-4">
// // //     <label className="block text-sm font-medium text-gray-700 mb-2">Tekst podtytułu</label>
// // //     <input
// // //       type="text"
// // //       value={heroData.subtitle}
// // //       onChange={(e) => handleInputChange('subtitle', e.target.value)}
// // //       className="w-full p-3 border border-gray-300 rounded-md"
// // //     />
// // //   </div>
  
// // //   <div className="grid grid-cols-2 gap-4 mb-4">
// // //     <div>
// // //       <label className="block text-sm font-medium text-gray-700 mb-2">Rozmiar czcionki</label>
// // //       <select
// // //         value={heroData.subtitleStyle.fontSize}
// // //         onChange={(e) => handleStyleChange('subtitleStyle', 'fontSize', e.target.value)}
// // //         className="w-full p-2 border border-gray-300 rounded-md"
// // //       >
// // //         {fontSizes.map((size) => (
// // //           <option key={size.value} value={size.value}>
// // //             {size.label}
// // //           </option>
// // //         ))}
// // //       </select>
// // //     </div>
    
// // //     <div>
// // //       <label className="block text-sm font-medium text-gray-700 mb-2">Grubość czcionki</label>
// // //       <select
// // //         value={heroData.subtitleStyle.fontWeight}
// // //         onChange={(e) => handleStyleChange('subtitleStyle', 'fontWeight', e.target.value)}
// // //         className="w-full p-2 border border-gray-300 rounded-md"
// // //       >
// // //         <option value="light">Light</option>
// // //         <option value="normal">Normal</option>
// // //         <option value="medium">Medium</option>
// // //         <option value="semibold">Semibold</option>
// // //         <option value="bold">Bold</option>
// // //         <option value="extrabold">Extrabold</option>
// // //       </select>
// // //     </div>
// // //   </div>
  
// // //   <div className="mb-4">
// // //     <label className="block text-sm font-medium text-gray-700 mb-2">Kolor tekstu</label>
// // //     <div className="flex items-center gap-2">
// // //       <input
// // //         type="color"
// // //         value={heroData.subtitleStyle.color}
// // //         onChange={(e) => handleStyleChange('subtitleStyle', 'color', e.target.value)}
// // //         className="w-10 h-10 rounded border border-gray-300"
// // //       />
// // //       <input
// // //         type="text"
// // //         value={heroData.subtitleStyle.color}
// // //         onChange={(e) => handleStyleChange('subtitleStyle', 'color', e.target.value)}
// // //         className="flex-1 p-2 border border-gray-300 rounded-md"
// // //       />
// // //     </div>
// // //   </div>
// // // </div>

// // // {/* Przycisk zapisu */}
// // // <div className="flex justify-end">
// // //   <button
// // //     onClick={saveData}
// // //     className="flex items-center gap-2 bg-green-500 hover:bg-green-600 text-white font-medium py-2 px-4 rounded-md"
// // //   >
// // //     <FaSave /> Zapisz zmiany
// // //   </button>
// // // </div>
// // // </div>

// // // {/* Podgląd */}
// // // <div className="p-4 border border-gray-200 rounded-md">
// // //   <h2 className="text-lg font-semibold mb-3">Podgląd sekcji Hero</h2>
// // //   <div className="border rounded-md overflow-hidden">
// // //     <section 
// // //       className="h-96 bg-cover bg-center flex items-center justify-center text-white relative transition-all duration-1000"
// // //       style={{ backgroundImage: `url('${heroData.images[currentSlideIndex]?.url}')` }}
// // //     >
// // //       {heroData.overlay.enabled && (
// // //         <div className={`absolute inset-0 ${heroData.overlay.gradient}`} />
// // //       )}
// // //       <div className="relative z-10 text-center px-4">
// // //         <h1 
// // //           className={`${getTailwindClasses(heroData.titleStyle, 'title')} mb-4 drop-shadow-lg`}
// // //           style={{ color: heroData.titleStyle.color }}
// // //         >
// // //           {heroData.title}
// // //         </h1>
// // //         <p 
// // //           className={`${getTailwindClasses(heroData.subtitleStyle, 'subtitle')} drop-shadow-lg`}
// // //           style={{ color: heroData.subtitleStyle.color }}
// // //         >
// // //           {heroData.subtitle}
// // //         </p>
// // //       </div>
      
// // //       {/* Wskaźniki slajdów */}
// // //       {heroData.images.length > 1 && (
// // //         <div className="absolute bottom-4 left-0 right-0 flex justify-center space-x-2 z-20">
// // //           {heroData.images.map((_, index) => (
// // //             <button
// // //               key={index}
// // //               onClick={() => setCurrentSlideIndex(index)}
// // //               className={`w-3 h-3 rounded-full ${
// // //                 index === currentSlideIndex ? 'bg-white' : 'bg-white/50'
// // //               }`}
// // //             />
// // //           ))}
// // //         </div>
// // //       )}
// // //     </section>
// // //   </div>
  
// // //   <div className="mt-4 p-3 bg-gray-50 rounded-md">
// // //     <h3 className="font-medium mb-2">Informacje</h3>
// // //     <p className="text-sm text-gray-600">
// // //       Sekcja Hero jest pierwszą rzeczą, którą widzą użytkownicy na stronie. 
// // //       Upewnij się, że tekst jest czytelny na tle wszystkich obrazów.
// // //       Aktualnie wyświetlany slajd: {currentSlideIndex + 1} z {heroData.images.length}
// // //     </p>
// // //   </div>
// // // </div>
// // // </div>
// // // </div>
// // // </div>
// // //   );
// // // };

// // // export default AdminHeroPanel;

// // import React, { useState, useEffect, useRef } from 'react';
// // import { FaSave, FaUpload, FaPlus, FaTrash, FaEyeDropper, FaFont } from 'react-icons/fa';

// // const AdminHeroPanel = () => {
// //   const defaultHeroData = {
// //     backgroundImages: [
// //       "/images/hero1.jpg",
// //       "/images/hero2.jpg",
// //       "/images/hero3.jpg",
// //       "/images/hero4.jpg",
// //       "/images/hero5.jpg"
// //     ],
// //     title: "Kolorowe Domki",
// //     subtitle: "Idealne miejsce nad morzem dla rodzin z dziećmi",
// //     titleStyle: {
// //       fontSize: "5xl",
// //       fontWeight: "extrabold",
// //       color: "#ffffff"
// //     },
// //     subtitleStyle: {
// //       fontSize: "xl",
// //       fontWeight: "light",
// //       color: "#ffffff"
// //     },
// //     overlay: {
// //       enabled: true,
// //       gradient: "bg-gradient-to-br from-black/60 to-black/30"
// //     },
// //     slideshowInterval: 5000
// //   };

// //   const [heroData, setHeroData] = useState(defaultHeroData);
// //   const [message, setMessage] = useState("");
// //   const [imageUploading, setImageUploading] = useState({});
// //   const [currentPreviewIndex, setCurrentPreviewIndex] = useState(0);
// //   const [isLoading, setIsLoading] = useState(true);
  
// //   // Ref dla ukrytego inputa do dodawania nowych obrazów
// //   const fileInputRef = useRef(null);

// //   // Załaduj dane z localStorage przy starcie
// //   useEffect(() => {
// //     const savedData = localStorage.getItem('heroData');
// //     if (savedData) {
// //       try {
// //         const parsedData = JSON.parse(savedData);
// //         // Upewnij się, że wszystkie wymagane pola istnieją
// //         setHeroData({
// //           ...defaultHeroData,
// //           ...parsedData,
// //           backgroundImages: parsedData.backgroundImages || defaultHeroData.backgroundImages,
// //           titleStyle: parsedData.titleStyle || defaultHeroData.titleStyle,
// //           subtitleStyle: parsedData.subtitleStyle || defaultHeroData.subtitleStyle,
// //           overlay: parsedData.overlay || defaultHeroData.overlay
// //         });
// //       } catch (error) {
// //         console.error('Błąd parsowania danych hero:', error);
// //         setHeroData(defaultHeroData);
// //       }
// //     }
// //     setIsLoading(false);
// //   }, []);

// //   const saveData = () => {
// //     localStorage.setItem('heroData', JSON.stringify(heroData));
// //     setMessage("Zmiany zapisane pomyślnie!");
// //     setTimeout(() => setMessage(""), 3000);
// //   };

// //   // Funkcje dla obrazów tła
// //   const handleBackgroundImageUpload = (e, index = null) => {
// //     const file = e.target.files[0];
// //     if (file) {
// //       const uploadKey = `bg-${index !== null ? index : 'new'}`;
// //       setImageUploading({ ...imageUploading, [uploadKey]: true });
      
// //       setTimeout(() => {
// //         const reader = new FileReader();
// //         reader.onload = (event) => {
// //           const newImageUrl = event.target.result;
// //           const updatedImages = [...(heroData.backgroundImages || [])];
          
// //           if (index !== null) {
// //             updatedImages[index] = newImageUrl;
// //           } else {
// //             updatedImages.push(newImageUrl);
// //           }
          
// //           setHeroData({
// //             ...heroData,
// //             backgroundImages: updatedImages
// //           });
// //           setImageUploading({ ...imageUploading, [uploadKey]: false });
// //         };
// //         reader.readAsDataURL(file);
// //       }, 1000);
// //     }
// //   };

// //   // Funkcja do wywołania kliknięcia w ukryty input
// //   const handleAddNewBackground = () => {
// //     fileInputRef.current?.click();
// //   };

// //   const removeBackgroundImage = (index) => {
// //     const currentImages = heroData.backgroundImages || [];
// //     if (currentImages.length <= 1) {
// //       setMessage("Musisz mieć przynajmniej jeden obraz tła!");
// //       setTimeout(() => setMessage(""), 3000);
// //       return;
// //     }
    
// //     setHeroData({
// //       ...heroData,
// //       backgroundImages: currentImages.filter((_, i) => i !== index)
// //     });
// //   };

// //   const moveBackgroundImage = (index, direction) => {
// //     const currentImages = heroData.backgroundImages || [];
// //     if ((direction === 'up' && index === 0) || 
// //         (direction === 'down' && index === currentImages.length - 1)) {
// //       return;
// //     }

// //     const updatedImages = [...currentImages];
// //     const targetIndex = direction === 'up' ? index - 1 : index + 1;
    
// //     [updatedImages[index], updatedImages[targetIndex]] = 
// //     [updatedImages[targetIndex], updatedImages[index]];
    
// //     setHeroData({
// //       ...heroData,
// //       backgroundImages: updatedImages
// //     });
// //   };

// //   // Funkcje dla tekstu
// //   const handleTextChange = (field, value) => {
// //     setHeroData({
// //       ...heroData,
// //       [field]: value
// //     });
// //   };

// //   // Funkcje dla stylów tekstu
// //   const handleStyleChange = (textType, property, value) => {
// //     setHeroData({
// //       ...heroData,
// //       [`${textType}Style`]: {
// //         ...(heroData[`${textType}Style`] || {}),
// //         [property]: value
// //       }
// //     });
// //   };

// //   // Funkcje dla overlay
// //   const handleOverlayChange = (field, value) => {
// //     setHeroData({
// //       ...heroData,
// //       overlay: {
// //         ...(heroData.overlay || {}),
// //         [field]: value
// //       }
// //     });
// //   };

// //   // Funkcje dla interwału slideshow
// //   const handleIntervalChange = (value) => {
// //     setHeroData({
// //       ...heroData,
// //       slideshowInterval: parseInt(value) || 5000
// //     });
// //   };

// //   // Predefiniowane gradienty
// //   const gradientOptions = [
// //     { value: "bg-gradient-to-br from-black/60 to-black/30", label: "Czarny gradient" },
// //     { value: "bg-gradient-to-br from-blue-900/60 to-blue-500/30", label: "Niebieski gradient" },
// //     { value: "bg-gradient-to-br from-purple-900/60 to-purple-500/30", label: "Fioletowy gradient" },
// //     { value: "bg-gradient-to-br from-orange-900/60 to-orange-500/30", label: "Pomarańczowy gradient" },
// //     { value: "bg-gradient-to-br from-green-900/60 to-green-500/30", label: "Zielony gradient" },
// //     { value: "bg-gradient-to-br from-red-900/60 to-red-500/30", label: "Czerwony gradient" },
// //     { value: "", label: "Brak overlay" }
// //   ];

// //   // Opcje rozmiaru czcionki
// //   const fontSizeOptions = [
// //     "xs", "sm", "base", "lg", "xl", "2xl", "3xl", "4xl", "5xl", "6xl", "7xl", "8xl", "9xl"
// //   ];

// //   // Opcje grubości czcionki
// //   const fontWeightOptions = [
// //     "thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black"
// //   ];

// //   if (isLoading) {
// //     return (
// //       <div className="min-h-screen bg-gray-100 p-6 flex items-center justify-center">
// //         <div className="text-center">
// //           <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500 mx-auto mb-4"></div>
// //           <p>Ładowanie danych...</p>
// //         </div>
// //       </div>
// //     );
// //   }

// //   const currentImages = heroData.backgroundImages || defaultHeroData.backgroundImages;

// //   return (
// //     <div className="min-h-screen bg-gray-100 p-6">
// //       <div className="max-w-6xl mx-auto bg-white rounded-lg shadow-md p-6">
// //         <h1 className="text-2xl font-bold mb-6 text-gray-800">Panel Administracyjny - Hero Section</h1>
        
// //         {message && (
// //           <div className="mb-4 p-3 bg-green-100 text-green-700 rounded">
// //             {message}
// //           </div>
// //         )}

// //         {/* Ukryty input dla dodawania nowych obrazów */}
// //         <input
// //           type="file"
// //           ref={fileInputRef}
// //           className="hidden"
// //           onChange={(e) => handleBackgroundImageUpload(e)}
// //           accept="image/*"
// //         />

// //         {/* Podgląd */}
// //         <div className="mb-8 p-4 border border-gray-200 rounded-md">
// //           <h2 className="text-lg font-semibold mb-4">Podgląd</h2>
// //           <div className="relative h-64 bg-cover bg-center rounded-md overflow-hidden" 
// //                style={{ backgroundImage: `url('${currentImages[currentPreviewIndex]}')` }}>
// //             {heroData.overlay?.enabled && (
// //               <div className={`absolute inset-0 ${heroData.overlay.gradient || 'bg-gradient-to-br from-black/60 to-black/30'}`} />
// //             )}
// //             <div className="relative z-10 text-center p-4 flex items-center justify-center h-full">
// //               <div>
// //                 <h1 
// //                   className={`text-${heroData.titleStyle?.fontSize || '5xl'} font-${heroData.titleStyle?.fontWeight || 'extrabold'} mb-2 drop-shadow-lg`}
// //                   style={{ color: heroData.titleStyle?.color || '#ffffff' }}
// //                 >
// //                   {heroData.title}
// //                 </h1>
// //                 <p 
// //                   className={`text-${heroData.subtitleStyle?.fontSize || 'xl'} font-${heroData.subtitleStyle?.fontWeight || 'light'} drop-shadow-lg`}
// //                   style={{ color: heroData.subtitleStyle?.color || '#ffffff' }}
// //                 >
// //                   {heroData.subtitle}
// //                 </p>
// //               </div>
// //             </div>
// //           </div>
          
// //           {/* Nawigacja podglądu */}
// //           <div className="flex justify-center mt-4 space-x-2">
// //             {currentImages.map((_, index) => (
// //               <button
// //                 key={index}
// //                 onClick={() => setCurrentPreviewIndex(index)}
// //                 className={`w-3 h-3 rounded-full ${
// //                   index === currentPreviewIndex ? 'bg-blue-500' : 'bg-gray-300'
// //                 }`}
// //               />
// //             ))}
// //           </div>
// //         </div>

// //         {/* Sekcja obrazów tła */}
// //         <div className="mb-8 p-4 border border-gray-200 rounded-md">
// //           <h2 className="text-lg font-semibold mb-4">Obrazy tła</h2>
          
// //           <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-4">
// //             {currentImages.map((image, index) => (
// //               <div key={index} className="border border-gray-200 rounded-md p-3">
// //                 <div className="relative group">
// //                   <img 
// //                     src={image} 
// //                     alt={`Tło ${index + 1}`} 
// //                     className="w-full h-32 object-cover rounded-md"
// //                   />
// //                   <div className="absolute inset-0 bg-black bg-opacity-50 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center">
// //                     <div className="flex space-x-2">
// //                       <button
// //                         onClick={() => moveBackgroundImage(index, 'up')}
// //                         disabled={index === 0}
// //                         className={`p-1 rounded ${index === 0 ? 'bg-gray-400' : 'bg-blue-500 text-white'}`}
// //                       >
// //                         ↑
// //                       </button>
// //                       <button
// //                         onClick={() => moveBackgroundImage(index, 'down')}
// //                         disabled={index === currentImages.length - 1}
// //                         className={`p-1 rounded ${index === currentImages.length - 1 ? 'bg-gray-400' : 'bg-blue-500 text-white'}`}
// //                       >
// //                         ↓
// //                       </button>
// //                       <button
// //                         onClick={() => removeBackgroundImage(index)}
// //                         className="p-1 bg-red-500 text-white rounded"
// //                       >
// //                         <FaTrash size={12} />
// //                       </button>
// //                     </div>
// //                   </div>
// //                 </div>
                
// //                 <label className="block mt-2 text-sm text-center">
// //                   <span className="flex items-center justify-center gap-1 bg-gray-100 py-1 rounded cursor-pointer hover:bg-gray-200">
// //                     <FaUpload size={12} />
// //                     Zmień
// //                   </span>
// //                   <input 
// //                     type="file" 
// //                     className="hidden" 
// //                     onChange={(e) => handleBackgroundImageUpload(e, index)} 
// //                     accept="image/*" 
// //                   />
// //                 </label>
// //               </div>
// //             ))}
// //           </div>

// //           <button
// //             onClick={handleAddNewBackground}
// //             className="flex items-center gap-2 bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600 transition-colors"
// //           >
// //             <FaPlus /> Dodaj nowe tło
// //           </button>
// //         </div>

// //         {/* Sekcja tekstu */}
// //         <div className="mb-8 p-4 border border-gray-200 rounded-md">
// //           <h2 className="text-lg font-semibold mb-4">Tekst główny</h2>
          
// //           <div className="grid md:grid-cols-2 gap-6">
// //             <div>
// //               <label className="block text-sm font-medium text-gray-700 mb-2">Tytuł</label>
// //               <input
// //                 type="text"
// //                 value={heroData.title || ''}
// //                 onChange={(e) => handleTextChange('title', e.target.value)}
// //                 className="w-full p-3 border border-gray-300 rounded-md"
// //               />
// //             </div>
            
// //             <div>
// //               <label className="block text-sm font-medium text-gray-700 mb-2">Podtytuł</label>
// //               <input
// //                 type="text"
// //                 value={heroData.subtitle || ''}
// //                 onChange={(e) => handleTextChange('subtitle', e.target.value)}
// //                 className="w-full p-3 border border-gray-300 rounded-md"
// //               />
// //             </div>
// //           </div>
// //         </div>

// //         {/* Sekcja stylów tekstu */}
// //         <div className="mb-8 p-4 border border-gray-200 rounded-md">
// //           <h2 className="text-lg font-semibold mb-4">Styl tekstu</h2>
          
// //           <div className="grid md:grid-cols-2 gap-8">
// //             {/* Styl tytułu */}
// //             <div>
// //               <h3 className="font-medium mb-4 flex items-center gap-2">
// //                 <FaFont /> Tytuł
// //               </h3>
              
// //               <div className="space-y-4">
// //                 <div>
// //                   <label className="block text-sm font-medium text-gray-700 mb-2">Rozmiar czcionki</label>
// //                   <select
// //                     value={heroData.titleStyle?.fontSize || '5xl'}
// //                     onChange={(e) => handleStyleChange('title', 'fontSize', e.target.value)}
// //                     className="w-full p-2 border border-gray-300 rounded-md"
// //                   >
// //                     {fontSizeOptions.map(size => (
// //                       <option key={size} value={size}>{size}</option>
// //                     ))}
// //                   </select>
// //                 </div>
                
// //                 <div>
// //                   <label className="block text-sm font-medium text-gray-700 mb-2">Grubość czcionki</label>
// //                   <select
// //                     value={heroData.titleStyle?.fontWeight || 'extrabold'}
// //                     onChange={(e) => handleStyleChange('title', 'fontWeight', e.target.value)}
// //                     className="w-full p-2 border border-gray-300 rounded-md"
// //                   >
// //                     {fontWeightOptions.map(weight => (
// //                       <option key={weight} value={weight}>{weight}</option>
// //                     ))}
// //                   </select>
// //                 </div>
                
// //                 <div>
// //                   <label className="block text-sm font-medium text-gray-700 mb-2">Kolor tekstu</label>
// //                   <div className="flex items-center gap-2">
// //                     <input
// //                       type="color"
// //                       value={heroData.titleStyle?.color || '#ffffff'}
// //                       onChange={(e) => handleStyleChange('title', 'color', e.target.value)}
// //                       className="w-10 h-10 rounded border border-gray-300"
// //                     />
// //                     <input
// //                       type="text"
// //                       value={heroData.titleStyle?.color || '#ffffff'}
// //                       onChange={(e) => handleStyleChange('title', 'color', e.target.value)}
// //                       className="flex-1 p-2 border border-gray-300 rounded-md"
// //                     />
// //                   </div>
// //                 </div>
// //               </div>
// //             </div>

// //             {/* Styl podtytułu */}
// //             <div>
// //               <h3 className="font-medium mb-4 flex items-center gap-2">
// //                 <FaFont /> Podtytuł
// //               </h3>
              
// //               <div className="space-y-4">
// //                 <div>
// //                   <label className="block text-sm font-medium text-gray-700 mb-2">Rozmiar czcionki</label>
// //                   <select
// //                     value={heroData.subtitleStyle?.fontSize || 'xl'}
// //                     onChange={(e) => handleStyleChange('subtitle', 'fontSize', e.target.value)}
// //                     className="w-full p-2 border border-gray-300 rounded-md"
// //                   >
// //                     {fontSizeOptions.map(size => (
// //                       <option key={size} value={size}>{size}</option>
// //                     ))}
// //                   </select>
// //                 </div>
                
// //                 <div>
// //                   <label className="block text-sm font-medium text-gray-700 mb-2">Grubość czcionki</label>
// //                   <select
// //                     value={heroData.subtitleStyle?.fontWeight || 'light'}
// //                     onChange={(e) => handleStyleChange('subtitle', 'fontWeight', e.target.value)}
// //                     className="w-full p-2 border border-gray-300 rounded-md"
// //                   >
// //                     {fontWeightOptions.map(weight => (
// //                       <option key={weight} value={weight}>{weight}</option>
// //                     ))}
// //                   </select>
// //                 </div>
                
// //                 <div>
// //                   <label className="block text-sm font-medium text-gray-700 mb-2">Kolor tekstu</label>
// //                   <div className="flex items-center gap-2">
// //                     <input
// //                       type="color"
// //                       value={heroData.subtitleStyle?.color || '#ffffff'}
// //                       onChange={(e) => handleStyleChange('subtitle', 'color', e.target.value)}
// //                       className="w-10 h-10 rounded border border-gray-300"
// //                     />
// //                     <input
// //                       type="text"
// //                       value={heroData.subtitleStyle?.color || '#ffffff'}
// //                       onChange={(e) => handleStyleChange('subtitle', 'color', e.target.value)}
// //                       className="flex-1 p-2 border border-gray-300 rounded-md"
// //                     />
// //                   </div>
// //                 </div>
// //               </div>
// //             </div>
// //           </div>
// //         </div>

// //         {/* Sekcja overlay */}
// //         <div className="mb-8 p-4 border border-gray-200 rounded-md">
// //           <h2 className="text-lg font-semibold mb-4">Overlay</h2>
          
// //           <div className="space-y-4">
// //             <div className="flex items-center gap-2">
// //               <input
// //                 type="checkbox"
// //                 id="overlayEnabled"
// //                 checked={heroData.overlay?.enabled || false}
// //                 onChange={(e) => handleOverlayChange('enabled', e.target.checked)}
// //                 className="w-4 h-4"
// //               />
// //               <label htmlFor="overlayEnabled" className="text-sm font-medium text-gray-700">
// //                 Włącz overlay
// //               </label>
// //             </div>
            
// //             {(heroData.overlay?.enabled) && (
// //               <div>
// //                 <label className="block text-sm font-medium text-gray-700 mb-2">Gradient overlay</label>
// //                 <select
// //                   value={heroData.overlay?.gradient || ''}
// //                   onChange={(e) => handleOverlayChange('gradient', e.target.value)}
// //                   className="w-full p-2 border border-gray-300 rounded-md"
// //                 >
// //                   {gradientOptions.map(option => (
// //                     <option key={option.value} value={option.value}>
// //                       {option.label}
// //                     </option>
// //                   ))}
// //                 </select>
// //               </div>
// //             )}
// //           </div>
// //         </div>

// //         {/* Sekcja ustawień slideshow */}
// //         <div className="mb-8 p-4 border border-gray-200 rounded-md">
// //           <h2 className="text-lg font-semibold mb-4">Ustawienia Slideshow</h2>
          
// //           <div>
// //             <label className="block text-sm font-medium text-gray-700 mb-2">
// //               Interwał zmiany slajdów (milisekundy)
// //             </label>
// //             <input
// //               type="number"
// //               value={heroData.slideshowInterval || 5000}
// //               onChange={(e) => handleIntervalChange(e.target.value)}
// //               min="1000"
// //               step="1000"
// //               className="w-full p-2 border border-gray-300 rounded-md"
// //             />
// //             <p className="text-sm text-gray-500 mt-1">
// //               Aktualny interwał: {(heroData.slideshowInterval || 5000) / 1000} sekund
// //             </p>
// //           </div>
// //         </div>

// //         {/* Zapisywanie */}
// //         <div className="flex justify-end">
// //           <button
// //             onClick={saveData}
// //             className="flex items-center gap-2 bg-green-500 hover:bg-green-600 text-white font-medium py-2 px-4 rounded-md"
// //           >
// //             <FaSave /> Zapisz zmiany
// //           </button>
// //         </div>
// //       </div>
// //     </div>
// //   );
// // };

// // export default AdminHeroPanel;

// import React, { useState, useEffect } from 'react';
// import { FaSave, FaUpload, FaPlus, FaTrash, FaFont } from 'react-icons/fa';

// const AdminHeroPanel = () => {
//   const API_BASE = 'http://localhost/api'; // Zmień na odpowiedni adres API

//   const defaultHeroData = {
//     backgroundImages: [
//       "/images/hero1.jpg",
//       "/images/hero2.jpg",
//       "/images/hero3.jpg",
//       "/images/hero4.jpg",
//       "/images/hero5.jpg"
//     ],
//     title: "Kolorowe Domki",
//     subtitle: "Idealne miejsce nad morzem dla rodzin z dziećmi",
//     titleStyle: {
//       fontSize: "6xl",
//       fontWeight: "extrabold",
//       color: "#ffffff"
//     },
//     subtitleStyle: {
//       fontSize: "2xl",
//       fontWeight: "light",
//       color: "#ffffff"
//     },
//     overlay: {
//       enabled: true,
//       gradient: "bg-gradient-to-br from-black/60 to-black/30"
//     },
//     slideshowInterval: 5000
//   };

//   const [heroData, setHeroData] = useState(defaultHeroData);
//   const [message, setMessage] = useState("");
//   const [isLoading, setIsLoading] = useState(true);
//   const [currentPreviewIndex, setCurrentPreviewIndex] = useState(0);

//   // Załaduj dane z serwera
//   useEffect(() => {
//     const fetchHeroData = async () => {
//       try {
//         setIsLoading(true);
//         const response = await fetch(`${API_BASE}/hero.php`);
        
//         if (!response.ok) {
//           throw new Error('Błąd podczas pobierania danych hero');
//         }
        
//         const data = await response.json();
//         setHeroData(data);
//       } catch (error) {
//         console.error('Błąd ładowania danych hero:', error);
//         setMessage('Używam domyślnych danych. Sprawdź połączenie z serwerem.');
//         setHeroData(defaultHeroData);
//       } finally {
//         setIsLoading(false);
//       }
//     };

//     fetchHeroData();
//   }, []);

//   const saveData = async () => {
//     try {
//       const response = await fetch(`${API_BASE}/hero.php`, {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify(heroData)
//       });

//       if (!response.ok) {
//         throw new Error('Błąd podczas zapisywania danych');
//       }

//       setMessage("Dane zapisane pomyślnie na serwerze!");
//       setTimeout(() => setMessage(""), 3000);
//     } catch (error) {
//       console.error('Błąd zapisywania:', error);
//       setMessage("Błąd zapisywania danych!");
//       setTimeout(() => setMessage(""), 3000);
//     }
//   };

//   // Funkcje dla obrazów tła
//   const handleBackgroundImageUpload = async (e, index = null) => {
//     const file = e.target.files[0];
//     if (!file) return;

//     const formData = new FormData();
//     formData.append('image', file);

//     try {
//       const response = await fetch(`${API_BASE}/upload.php`, {
//         method: 'POST',
//         body: formData
//       });

//       if (!response.ok) {
//         throw new Error('Błąd podczas uploadu obrazu');
//       }

//       const result = await response.json();
//       const newImageUrl = result.filePath;

//       const updatedImages = [...heroData.backgroundImages];
//       if (index !== null) {
//         updatedImages[index] = newImageUrl;
//       } else {
//         updatedImages.push(newImageUrl);
//       }

//       setHeroData({
//         ...heroData,
//         backgroundImages: updatedImages
//       });

//     } catch (error) {
//       console.error('Błąd uploadu:', error);
//       setMessage("Błąd podczas uploadu obrazu!");
//       setTimeout(() => setMessage(""), 3000);
//     }
//   };

//   const removeBackgroundImage = (index) => {
//     const currentImages = heroData.backgroundImages;
//     if (currentImages.length <= 1) {
//       setMessage("Musisz mieć przynajmniej jeden obraz tła!");
//       setTimeout(() => setMessage(""), 3000);
//       return;
//     }
    
//     setHeroData({
//       ...heroData,
//       backgroundImages: currentImages.filter((_, i) => i !== index)
//     });
//   };

//   // Funkcje dla tekstu
//   const handleTextChange = (field, value) => {
//     setHeroData({
//       ...heroData,
//       [field]: value
//     });
//   };

//   // Funkcje dla stylów tekstu
//   const handleStyleChange = (textType, property, value) => {
//     setHeroData({
//       ...heroData,
//       [`${textType}Style`]: {
//         ...heroData[`${textType}Style`],
//         [property]: value
//       }
//     });
//   };

//   // Funkcje dla overlay
//   const handleOverlayChange = (field, value) => {
//     setHeroData({
//       ...heroData,
//       overlay: {
//         ...heroData.overlay,
//         [field]: value
//       }
//     });
//   };

//   // Funkcje dla interwału slideshow
//   const handleIntervalChange = (value) => {
//     setHeroData({
//       ...heroData,
//       slideshowInterval: parseInt(value) || 5000
//     });
//   };

//   // Predefiniowane gradienty
//   const gradientOptions = [
//     { value: "bg-gradient-to-br from-black/60 to-black/30", label: "Czarny gradient" },
//     { value: "bg-gradient-to-br from-blue-900/60 to-blue-500/30", label: "Niebieski gradient" },
//     { value: "bg-gradient-to-br from-purple-900/60 to-purple-500/30", label: "Fioletowy gradient" },
//     { value: "bg-gradient-to-br from-orange-900/60 to-orange-500/30", label: "Pomarańczowy gradient" },
//     { value: "bg-gradient-to-br from-green-900/60 to-green-500/30", label: "Zielony gradient" },
//     { value: "bg-gradient-to-br from-red-900/60 to-red-500/30", label: "Czerwony gradient" },
//     { value: "", label: "Brak overlay" }
//   ];

//   if (isLoading) {
//     return (
//       <div className="min-h-screen bg-gray-100 p-6 flex items-center justify-center">
//         <div className="text-center">
//           <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500 mx-auto mb-4"></div>
//           <p>Ładowanie danych...</p>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="min-h-screen bg-gray-100 p-6">
//       <div className="max-w-6xl mx-auto bg-white rounded-lg shadow-md p-6">
//         <h1 className="text-2xl font-bold mb-6 text-gray-800">Panel Administracyjny - Hero Section</h1>
        
//         {message && (
//           <div className={`mb-4 p-3 rounded ${
//             message.includes('Błąd') ? 'bg-red-100 text-red-700' : 'bg-green-100 text-green-700'
//           }`}>
//             {message}
//           </div>
//         )}

//         {/* Podgląd */}
//         <div className="mb-8 p-4 border border-gray-200 rounded-md">
//           <h2 className="text-lg font-semibold mb-4">Podgląd</h2>
//           <div className="relative h-64 bg-cover bg-center rounded-md overflow-hidden" 
//                style={{ backgroundImage: `url('${heroData.backgroundImages[currentPreviewIndex]}')` }}>
//             {heroData.overlay.enabled && (
//               <div className={`absolute inset-0 ${heroData.overlay.gradient}`} />
//             )}
//             <div className="relative z-10 text-center p-4 flex items-center justify-center h-full">
//               <div>
//                 <h1 className="text-6xl font-extrabold mb-2 text-white">
//                   {heroData.title}
//                 </h1>
//                 <p className="text-2xl font-light text-white">
//                   {heroData.subtitle}
//                 </p>
//               </div>
//             </div>
//           </div>
          
//           {/* Nawigacja podglądu */}
//           <div className="flex justify-center mt-4 space-x-2">
//             {heroData.backgroundImages.map((_, index) => (
//               <button
//                 key={index}
//                 onClick={() => setCurrentPreviewIndex(index)}
//                 className={`w-3 h-3 rounded-full ${
//                   index === currentPreviewIndex ? 'bg-blue-500' : 'bg-gray-300'
//                 }`}
//               />
//             ))}
//           </div>
//         </div>

//         {/* Sekcja obrazów tła */}
//         <div className="mb-8 p-4 border border-gray-200 rounded-md">
//           <h2 className="text-lg font-semibold mb-4">Obrazy tła</h2>
          
//           <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-4">
//             {heroData.backgroundImages.map((image, index) => (
//               <div key={index} className="border border-gray-200 rounded-md p-3">
//                 <div className="relative group">
//                   <img 
//                     src={image} 
//                     alt={`Tło ${index + 1}`} 
//                     className="w-full h-32 object-cover rounded-md"
//                   />
//                   <div className="absolute inset-0 bg-black bg-opacity-50 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center">
//                     <button
//                       onClick={() => removeBackgroundImage(index)}
//                       className="p-2 bg-red-500 text-white rounded"
//                     >
//                       <FaTrash size={12} />
//                     </button>
//                   </div>
//                 </div>
                
//                 <label className="block mt-2 text-sm text-center">
//                   <span className="flex items-center justify-center gap-1 bg-gray-100 py-1 rounded cursor-pointer hover:bg-gray-200">
//                     <FaUpload size={12} />
//                     Zmień
//                   </span>
//                   <input 
//                     type="file" 
//                     className="hidden" 
//                     onChange={(e) => handleBackgroundImageUpload(e, index)} 
//                     accept="image/*" 
//                   />
//                 </label>
//               </div>
//             ))}
//           </div>

//           <label className="flex items-center gap-2 bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600 transition-colors cursor-pointer">
//             <FaPlus /> Dodaj nowe tło
//             <input 
//               type="file" 
//               className="hidden" 
//               onChange={(e) => handleBackgroundImageUpload(e)} 
//               accept="image/*" 
//             />
//           </label>
//         </div>

//         {/* Sekcja tekstu */}
//         <div className="mb-8 p-4 border border-gray-200 rounded-md">
//           <h2 className="text-lg font-semibold mb-4">Tekst główny</h2>
          
//           <div className="grid md:grid-cols-2 gap-6">
//             <div>
//               <label className="block text-sm font-medium text-gray-700 mb-2">Tytuł</label>
//               <input
//                 type="text"
//                 value={heroData.title}
//                 onChange={(e) => handleTextChange('title', e.target.value)}
//                 className="w-full p-3 border border-gray-300 rounded-md"
//                 placeholder="Wpisz tytuł"
//               />
//             </div>
            
//             <div>
//               <label className="block text-sm font-medium text-gray-700 mb-2">Podtytuł</label>
//               <input
//                 type="text"
//                 value={heroData.subtitle}
//                 onChange={(e) => handleTextChange('subtitle', e.target.value)}
//                 className="w-full p-3 border border-gray-300 rounded-md"
//                 placeholder="Wpisz podtytuł"
//               />
//             </div>
//           </div>
//         </div>

//         {/* Sekcja overlay */}
//         <div className="mb-8 p-4 border border-gray-200 rounded-md">
//           <h2 className="text-lg font-semibold mb-4">Overlay</h2>
          
//           <div className="space-y-4">
//             <div className="flex items-center gap-2">
//               <input
//                 type="checkbox"
//                 id="overlayEnabled"
//                 checked={heroData.overlay.enabled}
//                 onChange={(e) => handleOverlayChange('enabled', e.target.checked)}
//                 className="w-4 h-4"
//               />
//               <label htmlFor="overlayEnabled" className="text-sm font-medium text-gray-700">
//                 Włącz overlay
//               </label>
//             </div>
            
//             {heroData.overlay.enabled && (
//               <div>
//                 <label className="block text-sm font-medium text-gray-700 mb-2">Gradient overlay</label>
//                 <select
//                   value={heroData.overlay.gradient}
//                   onChange={(e) => handleOverlayChange('gradient', e.target.value)}
//                   className="w-full p-2 border border-gray-300 rounded-md"
//                 >
//                   {gradientOptions.map(option => (
//                     <option key={option.value} value={option.value}>
//                       {option.label}
//                     </option>
//                   ))}
//                 </select>
//               </div>
//             )}
//           </div>
//         </div>

//         {/* Sekcja ustawień slideshow */}
//         <div className="mb-8 p-4 border border-gray-200 rounded-md">
//           <h2 className="text-lg font-semibold mb-4">Ustawienia Slideshow</h2>
          
//           <div>
//             <label className="block text-sm font-medium text-gray-700 mb-2">
//               Interwał zmiany slajdów (milisekundy)
//             </label>
//             <input
//               type="number"
//               value={heroData.slideshowInterval}
//               onChange={(e) => handleIntervalChange(e.target.value)}
//               min="1000"
//               step="1000"
//               className="w-full p-2 border border-gray-300 rounded-md"
//             />
//             <p className="text-sm text-gray-500 mt-1">
//               Aktualny interwał: {heroData.slideshowInterval / 1000} sekund
//             </p>
//           </div>
//         </div>

//         {/* Zapisywanie */}
//         <div className="flex justify-end">
//           <button
//             onClick={saveData}
//             className="flex items-center gap-2 bg-green-500 hover:bg-green-600 text-white font-medium py-2 px-4 rounded-md"
//           >
//             <FaSave /> Zapisz zmiany
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default AdminHeroPanel;

// import React, { useState, useEffect } from 'react';
// import { FaSave, FaUpload, FaPlus, FaTrash } from 'react-icons/fa';

// const AdminHeroPanel = () => {
//   const API_BASE = 'http://localhost/api';

//   const defaultHeroData = {
//     backgroundImages: [
//       "/images/hero1.jpg",
//       "/images/hero2.jpg",
//       "/images/hero3.jpg",
//       "/images/hero4.jpg",
//       "/images/hero5.jpg"
//     ],
//     title: "Kolorowe Domki",
//     subtitle: "Idealne miejsce nad morzem dla rodzin z dziećmi",
//     titleStyle: {
//       fontSize: "6xl",
//       fontWeight: "extrabold",
//       color: "#ffffff"
//     },
//     subtitleStyle: {
//       fontSize: "2xl",
//       fontWeight: "light",
//       color: "#ffffff"
//     },
//     overlay: {
//       enabled: true,
//       gradient: "bg-gradient-to-br from-black/60 to-black/30"
//     },
//     slideshowInterval: 5000
//   };

//   const [heroData, setHeroData] = useState(defaultHeroData);
//   const [message, setMessage] = useState("");
//   const [isLoading, setIsLoading] = useState(true);
//   const [currentPreviewIndex, setCurrentPreviewIndex] = useState(0);

//   // Załaduj dane z serwera
//   useEffect(() => {
//     const fetchHeroData = async () => {
//       try {
//         setIsLoading(true);
//         const response = await fetch(`${API_BASE}/hero.php`);
        
//         if (!response.ok) {
//           throw new Error('Błąd podczas pobierania danych hero');
//         }
        
//         const data = await response.json();
//         setHeroData(data);
//       } catch (error) {
//         console.error('Błąd ładowania danych hero:', error);
//         setMessage('Używam domyślnych danych. Sprawdź połączenie z serwerem.');
//         setHeroData(defaultHeroData);
//       } finally {
//         setIsLoading(false);
//       }
//     };

//     fetchHeroData();
//   }, []);

//   const saveData = async () => {
//     try {
//       const response = await fetch(`${API_BASE}/hero.php`, {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify(heroData)
//       });

//       if (!response.ok) {
//         throw new Error('Błąd podczas zapisywania danych');
//       }

//       const result = await response.json();
//       setMessage(result.message || "Dane zapisane pomyślnie!");
//       setTimeout(() => setMessage(""), 3000);
//     } catch (error) {
//       console.error('Błąd zapisywania:', error);
//       setMessage("Błąd zapisywania danych!");
//       setTimeout(() => setMessage(""), 3000);
//     }
//   };

//   // Funkcje dla obrazów tła
//   const handleBackgroundImageUpload = async (e, index = null) => {
//     const file = e.target.files[0];
//     if (!file) return;

//     const formData = new FormData();
//     formData.append('image', file);

//     try {
//       const response = await fetch(`${API_BASE}/upload-hero.php`, {
//         method: 'POST',
//         body: formData
//       });

//       if (!response.ok) {
//         throw new Error('Błąd podczas uploadu obrazu');
//       }

//       const result = await response.json();
//       const newImageUrl = result.filePath;

//       const updatedImages = [...heroData.backgroundImages];
//       if (index !== null) {
//         updatedImages[index] = newImageUrl;
//       } else {
//         updatedImages.push(newImageUrl);
//       }

//       setHeroData({
//         ...heroData,
//         backgroundImages: updatedImages
//       });

//       setMessage("Obraz został pomyślnie przesłany!");
//       setTimeout(() => setMessage(""), 3000);

//     } catch (error) {
//       console.error('Błąd uploadu:', error);
//       setMessage("Błąd podczas uploadu obrazu!");
//       setTimeout(() => setMessage(""), 3000);
//     }
//   };

//   const removeBackgroundImage = (index) => {
//     const currentImages = heroData.backgroundImages;
//     if (currentImages.length <= 1) {
//       setMessage("Musisz mieć przynajmniej jeden obraz tła!");
//       setTimeout(() => setMessage(""), 3000);
//       return;
//     }
    
//     setHeroData({
//       ...heroData,
//       backgroundImages: currentImages.filter((_, i) => i !== index)
//     });
//   };

//   // Funkcje dla tekstu
//   const handleTextChange = (field, value) => {
//     setHeroData({
//       ...heroData,
//       [field]: value
//     });
//   };

//   // Funkcje dla stylów tekstu
//   const handleStyleChange = (textType, property, value) => {
//     setHeroData({
//       ...heroData,
//       [`${textType}Style`]: {
//         ...heroData[`${textType}Style`],
//         [property]: value
//       }
//     });
//   };

//   // Funkcje dla overlay
//   const handleOverlayChange = (field, value) => {
//     setHeroData({
//       ...heroData,
//       overlay: {
//         ...heroData.overlay,
//         [field]: value
//       }
//     });
//   };

//   // Funkcje dla interwału slideshow
//   const handleIntervalChange = (value) => {
//     setHeroData({
//       ...heroData,
//       slideshowInterval: parseInt(value) || 5000
//     });
//   };

//   // Predefiniowane gradienty
//   const gradientOptions = [
//     { value: "bg-gradient-to-br from-black/60 to-black/30", label: "Czarny gradient" },
//     { value: "bg-gradient-to-br from-blue-900/60 to-blue-500/30", label: "Niebieski gradient" },
//     { value: "bg-gradient-to-br from-purple-900/60 to-purple-500/30", label: "Fioletowy gradient" },
//     { value: "bg-gradient-to-br from-orange-900/60 to-orange-500/30", label: "Pomarańczowy gradient" },
//     { value: "bg-gradient-to-br from-green-900/60 to-green-500/30", label: "Zielony gradient" },
//     { value: "bg-gradient-to-br from-red-900/60 to-red-500/30", label: "Czerwony gradient" },
//     { value: "", label: "Brak overlay" }
//   ];

//   if (isLoading) {
//     return (
//       <div className="min-h-screen bg-gray-100 p-6 flex items-center justify-center">
//         <div className="text-center">
//           <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500 mx-auto mb-4"></div>
//           <p>Ładowanie danych...</p>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="min-h-screen bg-gray-100 p-6">
//       <div className="max-w-6xl mx-auto bg-white rounded-lg shadow-md p-6">
//         <h1 className="text-2xl font-bold mb-6 text-gray-800">Panel Administracyjny - Hero Section</h1>
        
//         {message && (
//           <div className={`mb-4 p-3 rounded ${
//             message.includes('Błąd') ? 'bg-red-100 text-red-700' : 'bg-green-100 text-green-700'
//           }`}>
//             {message}
//           </div>
//         )}

//         {/* Podgląd */}
//         <div className="mb-8 p-4 border border-gray-200 rounded-md">
//           <h2 className="text-lg font-semibold mb-4">Podgląd</h2>
//           <div className="relative h-64 bg-cover bg-center rounded-md overflow-hidden" 
//                style={{ backgroundImage: `url('${heroData.backgroundImages[currentPreviewIndex]}')` }}>
//             {heroData.overlay.enabled && (
//               <div className={`absolute inset-0 ${heroData.overlay.gradient}`} />
//             )}
//             <div className="relative z-10 text-center p-4 flex items-center justify-center h-full">
//               <div>
//                 <h1 className={`text-${heroData.titleStyle.fontSize} font-${heroData.titleStyle.fontWeight} mb-2`}
//                     style={{ color: heroData.titleStyle.color }}>
//                   {heroData.title}
//                 </h1>
//                 <p className={`text-${heroData.subtitleStyle.fontSize} font-${heroData.subtitleStyle.fontWeight}`}
//                    style={{ color: heroData.subtitleStyle.color }}>
//                   {heroData.subtitle}
//                 </p>
//               </div>
//             </div>
//           </div>
          
//           {/* Nawigacja podglądu */}
//           <div className="flex justify-center mt-4 space-x-2">
//             {heroData.backgroundImages.map((_, index) => (
//               <button
//                 key={index}
//                 onClick={() => setCurrentPreviewIndex(index)}
//                 className={`w-3 h-3 rounded-full ${
//                   index === currentPreviewIndex ? 'bg-blue-500' : 'bg-gray-300'
//                 }`}
//               />
//             ))}
//           </div>
//         </div>

//         {/* Sekcja obrazów tła */}
//         <div className="mb-8 p-4 border border-gray-200 rounded-md">
//           <h2 className="text-lg font-semibold mb-4">Obrazy tła</h2>
          
//           <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-4">
//             {heroData.backgroundImages.map((image, index) => (
//               <div key={index} className="border border-gray-200 rounded-md p-3">
//                 <div className="relative group">
//                   <img 
//                     src={image} 
//                     alt={`Tło ${index + 1}`} 
//                     className="w-full h-32 object-cover rounded-md"
//                   />
//                   <div className="absolute inset-0 bg-black bg-opacity-50 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center">
//                     <button
//                       onClick={() => removeBackgroundImage(index)}
//                       className="p-2 bg-red-500 text-white rounded"
//                     >
//                       <FaTrash size={12} />
//                     </button>
//                   </div>
//                 </div>
                
//                 <label className="block mt-2 text-sm text-center">
//                   <span className="flex items-center justify-center gap-1 bg-gray-100 py-1 rounded cursor-pointer hover:bg-gray-200">
//                     <FaUpload size={12} />
//                     Zmień
//                   </span>
//                   <input 
//                     type="file" 
//                     className="hidden" 
//                     onChange={(e) => handleBackgroundImageUpload(e, index)} 
//                     accept="image/*" 
//                   />
//                 </label>
//               </div>
//             ))}
//           </div>

//           <label className="inline-flex items-center gap-2 bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600 transition-colors cursor-pointer">
//             <FaPlus /> Dodaj nowe tło
//             <input 
//               type="file" 
//               className="hidden" 
//               onChange={(e) => handleBackgroundImageUpload(e)} 
//               accept="image/*" 
//             />
//           </label>
//         </div>

//         {/* Sekcja tekstu */}
//         <div className="mb-8 p-4 border border-gray-200 rounded-md">
//           <h2 className="text-lg font-semibold mb-4">Tekst główny</h2>
          
//           <div className="grid md:grid-cols-2 gap-6">
//             <div>
//               <label className="block text-sm font-medium text-gray-700 mb-2">Tytuł</label>
//               <input
//                 type="text"
//                 value={heroData.title}
//                 onChange={(e) => handleTextChange('title', e.target.value)}
//                 className="w-full p-3 border border-gray-300 rounded-md"
//                 placeholder="Wpisz tytuł"
//               />
//             </div>
            
//             <div>
//               <label className="block text-sm font-medium text-gray-700 mb-2">Podtytuł</label>
//               <input
//                 type="text"
//                 value={heroData.subtitle}
//                 onChange={(e) => handleTextChange('subtitle', e.target.value)}
//                 className="w-full p-3 border border-gray-300 rounded-md"
//                 placeholder="Wpisz podtytuł"
//               />
//             </div>
//           </div>
//         </div>

//         {/* Sekcja stylów tekstu */}
//         <div className="mb-8 p-4 border border-gray-200 rounded-md">
//           <h2 className="text-lg font-semibold mb-4">Style tekstu</h2>
          
//           <div className="grid md:grid-cols-2 gap-6">
//             <div>
//               <h3 className="text-md font-medium mb-3">Styl tytułu</h3>
              
//               <div className="mb-3">
//                 <label className="block text-sm font-medium text-gray-700 mb-1">Rozmiar czcionki</label>
//                 <select
//                   value={heroData.titleStyle.fontSize}
//                   onChange={(e) => handleStyleChange('title', 'fontSize', e.target.value)}
//                   className="w-full p-2 border border-gray-300 rounded-md"
//                 >
//                   <option value="4xl">4XL (bardzo duży)</option>
//                   <option value="5xl">5XL (ogromny)</option>
//                   <option value="6xl">6XL (bardzo ogromny)</option>
//                   <option value="7xl">7XL (gigantyczny)</option>
//                 </select>
//               </div>
              
//               <div className="mb-3">
//                 <label className="block text-sm font-medium text-gray-700 mb-1">Grubość czcionki</label>
//                 <select
//                   value={heroData.titleStyle.fontWeight}
//                   onChange={(e) => handleStyleChange('title', 'fontWeight', e.target.value)}
//                   className="w-full p-2 border border-gray-300 rounded-md"
//                 >
//                   <option value="normal">Normalna</option>
//                   <option value="medium">Średnia</option>
//                   <option value="semibold">Półgruba</option>
//                   <option value="bold">Gruba</option>
//                   <option value="extrabold">Bardzo gruba</option>
//                 </select>
//               </div>
              
//               <div>
//                 <label className="block text-sm font-medium text-gray-700 mb-1">Kolor tekstu</label>
//                 <input
//                   type="color"
//                   value={heroData.titleStyle.color}
//                   onChange={(e) => handleStyleChange('title', 'color', e.target.value)}
//                   className="w-full h-10 p-1 border border-gray-300 rounded-md"
//                 />
//               </div>
//             </div>
            
//             <div>
//               <h3 className="text-md font-medium mb-3">Styl podtytułu</h3>
              
//               <div className="mb-3">
//                 <label className="block text-sm font-medium text-gray-700 mb-1">Rozmiar czcionki</label>
//                 <select
//                   value={heroData.subtitleStyle.fontSize}
//                   onChange={(e) => handleStyleChange('subtitle', 'fontSize', e.target.value)}
//                   className="w-full p-2 border border-gray-300 rounded-md"
//                 >
//                   <option value="xl">XL (duży)</option>
//                   <option value="2xl">2XL (bardzo duży)</option>
//                   <option value="3xl">3XL (ogromny)</option>
//                   <option value="4xl">4XL (bardzo ogromny)</option>
//                 </select>
//               </div>
              
//               <div className="mb-3">
//                 <label className="block text-sm font-medium text-gray-700 mb-1">Grubość czcionki</label>
//                 <select
//                   value={heroData.subtitleStyle.fontWeight}
//                   onChange={(e) => handleStyleChange('subtitle', 'fontWeight', e.target.value)}
//                   className="w-full p-2 border border-gray-300 rounded-md"
//                 >
//                   <option value="light">Cienka</option>
//                   <option value="normal">Normalna</option>
//                   <option value="medium">Średnia</option>
//                   <option value="semibold">Półgruba</option>
//                 </select>
//               </div>
              
//               <div>
//                 <label className="block text-sm font-medium text-gray-700 mb-1">Kolor tekstu</label>
//                 <input
//                   type="color"
//                   value={heroData.subtitleStyle.color}
//                   onChange={(e) => handleStyleChange('subtitle', 'color', e.target.value)}
//                   className="w-full h-10 p-1 border border-gray-300 rounded-md"
//                 />
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Sekcja overlay */}
//         <div className="mb-8 p-4 border border-gray-200 rounded-md">
//           <h2 className="text-lg font-semibold mb-4">Overlay</h2>
          
//           <div className="space-y-4">
//             <div className="flex items-center gap-2">
//               <input
//                 type="checkbox"
//                 id="overlayEnabled"
//                 checked={heroData.overlay.enabled}
//                 onChange={(e) => handleOverlayChange('enabled', e.target.checked)}
//                 className="w-4 h-4"
//               />
//               <label htmlFor="overlayEnabled" className="text-sm font-medium text-gray-700">
//                 Włącz overlay
//               </label>
//             </div>
            
//             {heroData.overlay.enabled && (
//               <div>
//                 <label className="block text-sm font-medium text-gray-700 mb-2">Gradient overlay</label>
//                 <select
//                   value={heroData.overlay.gradient}
//                   onChange={(e) => handleOverlayChange('gradient', e.target.value)}
//                   className="w-full p-2 border border-gray-300 rounded-md"
//                 >
//                   {gradientOptions.map(option => (
//                     <option key={option.value} value={option.value}>
//                       {option.label}
//                     </option>
//                   ))}
//                 </select>
//               </div>
//             )}
//           </div>
//         </div>

//         {/* Sekcja ustawień slideshow */}
//         <div className="mb-8 p-4 border border-gray-200 rounded-md">
//           <h2 className="text-lg font-semibold mb-4">Ustawienia Slideshow</h2>
          
//           <div>
//             <label className="block text-sm font-medium text-gray-700 mb-2">
//               Interwał zmiany slajdów (milisekundy)
//             </label>
//             <input
//               type="number"
//               value={heroData.slideshowInterval}
//               onChange={(e) => handleIntervalChange(e.target.value)}
//               min="1000"
//               step="1000"
//               className="w-full p-2 border border-gray-300 rounded-md"
//             />
//             <p className="text-sm text-gray-500 mt-1">
//               Aktualny interwał: {heroData.slideshowInterval / 1000} sekund
//             </p>
//           </div>
//         </div>

//         {/* Zapisywanie */}
//         <div className="flex justify-end">
//           <button
//             onClick={saveData}
//             className="flex items-center gap-2 bg-green-500 hover:bg-green-600 text-white font-medium py-2 px-4 rounded-md"
//           >
//             <FaSave /> Zapisz zmiany
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default AdminHeroPanel;

import React, { useState, useEffect } from 'react';
import { FaSave, FaUpload, FaPlus, FaTrash } from 'react-icons/fa';

const AdminHeroPanel = () => {
  const API_BASE = 'http://localhost/api';

  const defaultHeroData = {
    backgroundImages: [
      "/images/hero1.jpg",
      "/images/hero2.jpg",
      "/images/hero3.jpg",
      "/images/hero4.jpg",
      "/images/hero5.jpg"
    ],
    title: "Kolorowe Domki",
    subtitle: "Idealne miejsce nad morzem dla rodzin z dziećmi",
    titleStyle: {
      fontSize: "6xl",
      fontWeight: "extrabold",
      color: "#ffffff"
    },
    subtitleStyle: {
      fontSize: "2xl",
      fontWeight: "light",
      color: "#ffffff"
    },
    overlay: {
      enabled: true,
      gradient: "bg-gradient-to-br from-black/60 to-black/30"
    },
    slideshowInterval: 5000
  };

  const [heroData, setHeroData] = useState(defaultHeroData);
  const [message, setMessage] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [currentPreviewIndex, setCurrentPreviewIndex] = useState(0);

  // Załaduj dane z serwera
  useEffect(() => {
    const fetchHeroData = async () => {
      try {
        setIsLoading(true);
        const response = await fetch(`${API_BASE}/hero.php`);
        
        if (!response.ok) {
          throw new Error('Błąd podczas pobierania danych hero');
        }
        
        const data = await response.json();
        // Upewnij się, że wszystkie pola istnieją
        const safeData = {
          ...defaultHeroData,
          ...data,
          titleStyle: {
            ...defaultHeroData.titleStyle,
            ...(data.titleStyle || {})
          },
          subtitleStyle: {
            ...defaultHeroData.subtitleStyle,
            ...(data.subtitleStyle || {})
          },
          overlay: {
            ...defaultHeroData.overlay,
            ...(data.overlay || {})
          }
        };
        setHeroData(safeData);
      } catch (error) {
        console.error('Błąd ładowania danych hero:', error);
        setMessage('Używam domyślnych danych. Sprawdź połączenie z serwerem.');
        setHeroData(defaultHeroData);
      } finally {
        setIsLoading(false);
      }
    };

    fetchHeroData();
  }, []);

  const saveData = async () => {
    try {
      const response = await fetch(`${API_BASE}/hero.php`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(heroData)
      });

      if (!response.ok) {
        throw new Error('Błąd podczas zapisywania danych');
      }

      const result = await response.json();
      setMessage(result.message || "Dane zapisane pomyślnie!");
      setTimeout(() => setMessage(""), 3000);
    } catch (error) {
      console.error('Błąd zapisywania:', error);
      setMessage("Błąd zapisywania danych!");
      setTimeout(() => setMessage(""), 3000);
    }
  };

  // Funkcje dla obrazów tła
  const handleBackgroundImageUpload = async (e, index = null) => {
    const file = e.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append('image', file);

    try {
      const response = await fetch(`${API_BASE}/upload-hero.php`, {
        method: 'POST',
        body: formData
      });

      if (!response.ok) {
        throw new Error('Błąd podczas uploadu obrazu');
      }

      const result = await response.json();
      const newImageUrl = result.filePath;

      const updatedImages = [...heroData.backgroundImages];
      if (index !== null) {
        updatedImages[index] = newImageUrl;
      } else {
        updatedImages.push(newImageUrl);
      }

      setHeroData({
        ...heroData,
        backgroundImages: updatedImages
      });

      setMessage("Obraz został pomyślnie przesłany!");
      setTimeout(() => setMessage(""), 3000);

    } catch (error) {
      console.error('Błąd uploadu:', error);
      setMessage("Błąd podczas uploadu obrazu!");
      setTimeout(() => setMessage(""), 3000);
    }
  };

  const removeBackgroundImage = (index) => {
    const currentImages = heroData.backgroundImages;
    if (currentImages.length <= 1) {
      setMessage("Musisz mieć przynajmniej jeden obraz tła!");
      setTimeout(() => setMessage(""), 3000);
      return;
    }
    
    setHeroData({
      ...heroData,
      backgroundImages: currentImages.filter((_, i) => i !== index)
    });
  };

  // Funkcje dla tekstu
  const handleTextChange = (field, value) => {
    setHeroData({
      ...heroData,
      [field]: value
    });
  };

  // Funkcje dla stylów tekstu - z zabezpieczeniem
  const handleStyleChange = (textType, property, value) => {
    setHeroData({
      ...heroData,
      [`${textType}Style`]: {
        ...(heroData[`${textType}Style`] || {}),
        [property]: value
      }
    });
  };

  // Funkcje dla overlay - z zabezpieczeniem
  const handleOverlayChange = (field, value) => {
    setHeroData({
      ...heroData,
      overlay: {
        ...(heroData.overlay || {}),
        [field]: value
      }
    });
  };

  // Funkcje dla interwału slideshow
  const handleIntervalChange = (value) => {
    setHeroData({
      ...heroData,
      slideshowInterval: parseInt(value) || 5000
    });
  };

  // Predefiniowane gradienty
  const gradientOptions = [
    { value: "bg-gradient-to-br from-black/60 to-black/30", label: "Czarny gradient" },
    { value: "bg-gradient-to-br from-blue-900/60 to-blue-500/30", label: "Niebieski gradient" },
    { value: "bg-gradient-to-br from-purple-900/60 to-purple-500/30", label: "Fioletowy gradient" },
    { value: "bg-gradient-to-br from-orange-900/60 to-orange-500/30", label: "Pomarańczowy gradient" },
    { value: "bg-gradient-to-br from-green-900/60 to-green-500/30", label: "Zielony gradient" },
    { value: "bg-gradient-to-br from-red-900/60 to-red-500/30", label: "Czerwony gradient" },
    { value: "", label: "Brak overlay" }
  ];

  // Bezpieczne pobieranie wartości stylów
  const getSafeStyleValue = (style, property, defaultValue) => {
    return style?.[property] || defaultValue;
  };

  if (isLoading) {
    return (
      <div className="min-h-screen bg-gray-100 p-6 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500 mx-auto mb-4"></div>
          <p>Ładowanie danych...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-100 p-6">
      <div className="max-w-6xl mx-auto bg-white rounded-lg shadow-md p-6">
        <h1 className="text-2xl font-bold mb-6 text-gray-800">Panel Administracyjny - Hero Section</h1>
        
        {message && (
          <div className={`mb-4 p-3 rounded ${
            message.includes('Błąd') ? 'bg-red-100 text-red-700' : 'bg-green-100 text-green-700'
          }`}>
            {message}
          </div>
        )}

        {/* Podgląd */}
        <div className="mb-8 p-4 border border-gray-200 rounded-md">
          <h2 className="text-lg font-semibold mb-4">Podgląd</h2>
          <div className="relative h-64 bg-cover bg-center rounded-md overflow-hidden" 
               style={{ backgroundImage: `url('${heroData.backgroundImages[currentPreviewIndex]}')` }}>
            {heroData.overlay?.enabled && (
              <div className={`absolute inset-0 ${heroData.overlay?.gradient || 'bg-gradient-to-br from-black/60 to-black/30'}`} />
            )}
            <div className="relative z-10 text-center p-4 flex items-center justify-center h-full">
              <div>
                <h1 className={`text-${getSafeStyleValue(heroData.titleStyle, 'fontSize', '6xl')} font-${getSafeStyleValue(heroData.titleStyle, 'fontWeight', 'extrabold')} mb-2`}
                    style={{ color: getSafeStyleValue(heroData.titleStyle, 'color', '#ffffff') }}>
                  {heroData.title}
                </h1>
                <p className={`text-${getSafeStyleValue(heroData.subtitleStyle, 'fontSize', '2xl')} font-${getSafeStyleValue(heroData.subtitleStyle, 'fontWeight', 'light')}`}
                   style={{ color: getSafeStyleValue(heroData.subtitleStyle, 'color', '#ffffff') }}>
                  {heroData.subtitle}
                </p>
              </div>
            </div>
          </div>
          
          {/* Nawigacja podglądu */}
          <div className="flex justify-center mt-4 space-x-2">
            {heroData.backgroundImages.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentPreviewIndex(index)}
                className={`w-3 h-3 rounded-full ${
                  index === currentPreviewIndex ? 'bg-blue-500' : 'bg-gray-300'
                }`}
              />
            ))}
          </div>
        </div>

        {/* Sekcja obrazów tła */}
        <div className="mb-8 p-4 border border-gray-200 rounded-md">
          <h2 className="text-lg font-semibold mb-4">Obrazy tła</h2>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-4">
            {heroData.backgroundImages.map((image, index) => (
              <div key={index} className="border border-gray-200 rounded-md p-3">
                <div className="relative group">
                  <img 
                    src={image} 
                    alt={`Tło ${index + 1}`} 
                    className="w-full h-32 object-cover rounded-md"
                  />
                  <div className="absolute inset-0 bg-black bg-opacity-50 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center">
                    <button
                      onClick={() => removeBackgroundImage(index)}
                      className="p-2 bg-red-500 text-white rounded"
                    >
                      <FaTrash size={12} />
                    </button>
                  </div>
                </div>
                
                <label className="block mt-2 text-sm text-center">
                  <span className="flex items-center justify-center gap-1 bg-gray-100 py-1 rounded cursor-pointer hover:bg-gray-200">
                    <FaUpload size={12} />
                    Zmień
                  </span>
                  <input 
                    type="file" 
                    className="hidden" 
                    onChange={(e) => handleBackgroundImageUpload(e, index)} 
                    accept="image/*" 
                  />
                </label>
              </div>
            ))}
          </div>

          <label className="inline-flex items-center gap-2 bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600 transition-colors cursor-pointer">
            <FaPlus /> Dodaj nowe tło
            <input 
              type="file" 
              className="hidden" 
              onChange={(e) => handleBackgroundImageUpload(e)} 
              accept="image/*" 
            />
          </label>
        </div>

        {/* Sekcja tekstu */}
        <div className="mb-8 p-4 border border-gray-200 rounded-md">
          <h2 className="text-lg font-semibold mb-4">Tekst główny</h2>
          
          <div className="grid md:grid-cols-2 gap-6">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Tytuł</label>
              <input
                type="text"
                value={heroData.title || ''}
                onChange={(e) => handleTextChange('title', e.target.value)}
                className="w-full p-3 border border-gray-300 rounded-md"
                placeholder="Wpisz tytuł"
              />
            </div>
            
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Podtytuł</label>
              <input
                type="text"
                value={heroData.subtitle || ''}
                onChange={(e) => handleTextChange('subtitle', e.target.value)}
                className="w-full p-3 border border-gray-300 rounded-md"
                placeholder="Wpisz podtytuł"
              />
            </div>
          </div>
        </div>

        {/* Sekcja stylów tekstu */}
        <div className="mb-8 p-4 border border-gray-200 rounded-md">
          <h2 className="text-lg font-semibold mb-4">Style tekstu</h2>
          
          <div className="grid md:grid-cols-2 gap-6">
            <div>
              <h3 className="text-md font-medium mb-3">Styl tytułu</h3>
              
              <div className="mb-3">
                <label className="block text-sm font-medium text-gray-700 mb-1">Rozmiar czcionki</label>
                <select
                  value={getSafeStyleValue(heroData.titleStyle, 'fontSize', '6xl')}
                  onChange={(e) => handleStyleChange('title', 'fontSize', e.target.value)}
                  className="w-full p-2 border border-gray-300 rounded-md"
                >
                  <option value="4xl">4XL (bardzo duży)</option>
                  <option value="5xl">5XL (ogromny)</option>
                  <option value="6xl">6XL (bardzo ogromny)</option>
                  <option value="7xl">7XL (gigantyczny)</option>
                </select>
              </div>
              
              <div className="mb-3">
                <label className="block text-sm font-medium text-gray-700 mb-1">Grubość czcionki</label>
                <select
                  value={getSafeStyleValue(heroData.titleStyle, 'fontWeight', 'extrabold')}
                  onChange={(e) => handleStyleChange('title', 'fontWeight', e.target.value)}
                  className="w-full p-2 border border-gray-300 rounded-md"
                >
                  <option value="normal">Normalna</option>
                  <option value="medium">Średnia</option>
                  <option value="semibold">Półgruba</option>
                  <option value="bold">Gruba</option>
                  <option value="extrabold">Bardzo gruba</option>
                </select>
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Kolor tekstu</label>
                <input
                  type="color"
                  value={getSafeStyleValue(heroData.titleStyle, 'color', '#ffffff')}
                  onChange={(e) => handleStyleChange('title', 'color', e.target.value)}
                  className="w-full h-10 p-1 border border-gray-300 rounded-md"
                />
              </div>
            </div>
            
            <div>
              <h3 className="text-md font-medium mb-3">Styl podtytułu</h3>
              
              <div className="mb-3">
                <label className="block text-sm font-medium text-gray-700 mb-1">Rozmiar czcionki</label>
                <select
                  value={getSafeStyleValue(heroData.subtitleStyle, 'fontSize', '2xl')}
                  onChange={(e) => handleStyleChange('subtitle', 'fontSize', e.target.value)}
                  className="w-full p-2 border border-gray-300 rounded-md"
                >
                  <option value="xl">XL (duży)</option>
                  <option value="2xl">2XL (bardzo duży)</option>
                  <option value="3xl">3XL (ogromny)</option>
                  <option value="4xl">4XL (bardzo ogromny)</option>
                </select>
              </div>
              
              <div className="mb-3">
                <label className="block text-sm font-medium text-gray-700 mb-1">Grubość czcionki</label>
                <select
                  value={getSafeStyleValue(heroData.subtitleStyle, 'fontWeight', 'light')}
                  onChange={(e) => handleStyleChange('subtitle', 'fontWeight', e.target.value)}
                  className="w-full p-2 border border-gray-300 rounded-md"
                >
                  <option value="light">Cienka</option>
                  <option value="normal">Normalna</option>
                  <option value="medium">Średnia</option>
                  <option value="semibold">Półgruba</option>
                </select>
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Kolor tekstu</label>
                <input
                  type="color"
                  value={getSafeStyleValue(heroData.subtitleStyle, 'color', '#ffffff')}
                  onChange={(e) => handleStyleChange('subtitle', 'color', e.target.value)}
                  className="w-full h-10 p-1 border border-gray-300 rounded-md"
                />
              </div>
            </div>
          </div>
        </div>

        {/* Sekcja overlay */}
        <div className="mb-8 p-4 border border-gray-200 rounded-md">
          <h2 className="text-lg font-semibold mb-4">Overlay</h2>
          
          <div className="space-y-4">
            <div className="flex items-center gap-2">
              <input
                type="checkbox"
                id="overlayEnabled"
                checked={heroData.overlay?.enabled || false}
                onChange={(e) => handleOverlayChange('enabled', e.target.checked)}
                className="w-4 h-4"
              />
              <label htmlFor="overlayEnabled" className="text-sm font-medium text-gray-700">
                Włącz overlay
              </label>
            </div>
            
            {(heroData.overlay?.enabled) && (
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Gradient overlay</label>
                <select
                  value={heroData.overlay?.gradient || ''}
                  onChange={(e) => handleOverlayChange('gradient', e.target.value)}
                  className="w-full p-2 border border-gray-300 rounded-md"
                >
                  {gradientOptions.map(option => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </select>
              </div>
            )}
          </div>
        </div>

        {/* Sekcja ustawień slideshow */}
        <div className="mb-8 p-4 border border-gray-200 rounded-md">
          <h2 className="text-lg font-semibold mb-4">Ustawienia Slideshow</h2>
          
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Interwał zmiany slajdów (milisekundy)
            </label>
            <input
              type="number"
              value={heroData.slideshowInterval || 5000}
              onChange={(e) => handleIntervalChange(e.target.value)}
              min="1000"
              step="1000"
              className="w-full p-2 border border-gray-300 rounded-md"
            />
            <p className="text-sm text-gray-500 mt-1">
              Aktualny interwał: {(heroData.slideshowInterval || 5000) / 1000} sekund
            </p>
          </div>
        </div>

        {/* Zapisywanie */}
        <div className="flex justify-end">
          <button
            onClick={saveData}
            className="flex items-center gap-2 bg-green-500 hover:bg-green-600 text-white font-medium py-2 px-4 rounded-md"
          >
            <FaSave /> Zapisz zmiany
          </button>
        </div>
      </div>
    </div>
  );
};

export default AdminHeroPanel;